<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>

    <section class="dp-right" style="position: relative;">
      <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList" />

      <div class="special-course-batch-bar">
        <span class="special-course-batch-bar__label">批量与导入</span>
        <el-button type="info" plain icon="el-icon-date" @click="goScheduleCalendar">排班日历</el-button>
        <el-button type="primary" icon="el-icon-magic-stick" @click="openBatchGenerate">批量生成班次</el-button>
        <el-button type="success" icon="el-icon-upload2" @click="openBatchImportWeek">周模板矩阵导入</el-button>
        <el-button type="success" icon="el-icon-date" @click="openBatchImportMonth">日历矩阵导入</el-button>
      </div>

      <div class="tbl-scroll-host">
      <el-table :data="list" v-loading="listLoading" highlight-current-row @selection-change="onSessionSelectionChange"
        @row-click="selectCurrentRow" ref="table" class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"></el-table-column>
        <!-- 两两合并：班次名称+校区、关联时间+关联班级。最后更新：2026-10-27 -->
        <el-table-column label="班次 / 校区" min-width="160" align="center">
          <template slot-scope="scope">
            <div class="scs-session-cell scs-session-cell--center">
              <el-tooltip
                :content="scope.row.SessionName || '—'"
                placement="top"
                :open-delay="250"
                :disabled="!scope.row.SessionName"
              >
                <div class="scs-session-cell__name">{{ scope.row.SessionName || '—' }}</div>
              </el-tooltip>
              <div class="scs-session-cell__sub" :title="scope.row.CampusName || ''">
                {{ scope.row.CampusName || '—' }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="时间 / 班级" min-width="160" align="center">
          <template slot-scope="scope">
            <div class="scs-session-cell scs-session-cell--center">
              <div class="scs-session-cell__name scs-session-cell__name--normal">
                {{ scope.row.SpecialCourseTimeName || '—' }}
              </div>
              <div class="scs-session-cell__sub" :title="scope.row.ClassName || ''">
                {{ scope.row.ClassName || '—' }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="学生组成" min-width="260" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.StudentType === 1 ? 'info' : (scope.row.StudentType === 2 ? 'primary' : 'warning')" size="small">
              <span class="scope-tag-text">{{ studentScopeLabel(scope.row) }}</span>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="默认教师" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <template v-if="scope.row.DefaultTeachers && scope.row.DefaultTeachers.length">
              <el-tag v-for="t in scope.row.DefaultTeachers" :key="t.TeacherId" size="mini" type="primary" effect="plain" style="margin-right:4px">
                {{ t.TeacherName }}
              </el-tag>
            </template>
            <span v-else class="text-muted">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="SortOrder" label="排序" width="70"></el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.IsEnable ? 'success' : 'danger'">
              {{ scope.row.IsEnable ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" class="op-edit"
              @click.stop="openTeacherDialog(scope.row)">配置教师</el-button>
            <el-button size="mini" type="text" class="op-link"
              @click.stop="goSchedule(scope.row)">排班管理</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100,200,500]"
          :current-page="page" :page-size="pageSize" :total="total" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" style="float: right">
        </el-pagination>
      </el-col>

      <!-- 新增/编辑班次弹窗 -->
      <el-dialog
        :title="formTitle"
        :visible.sync="formVisible"
        :close-on-click-modal="false"
        width="580px"
        custom-class="scs-session-dialog"
        top="6vh"
      >
        <el-form :model="editForm" label-width="88px" :rules="formRules" ref="editForm" class="scs-session-form">
          <section class="scs-form-section">
            <header class="scs-form-section__head">
              <span class="scs-form-section__title">基本信息</span>
            </header>
            <el-form-item label="班次名称" prop="SessionName">
              <el-input v-model="editForm.SessionName" placeholder="如：高一晚自习A班" clearable />
            </el-form-item>
            <el-form-item label="所属校区" prop="CampusId">
              <el-select
                v-model="editForm.CampusId"
                placeholder="请选择所属校区"
                style="width:100%"
                :clearable="false"
                @change="onSessionCampusChange"
              >
                <el-option v-for="c in campusOptions" :key="c.Id" :label="c.Name" :value="c.Id" />
              </el-select>
              <p class="campus-form-tip">先选校区，再选时间与班级；若时间模板已绑定校区，保存时以模板校区为准。</p>
            </el-form-item>
            <el-form-item label="关联时间" prop="SpecialCourseTimeId">
              <el-select
                v-model="editForm.SpecialCourseTimeId"
                :placeholder="formHasCampus ? '请选择课程时间' : '请先选择所属校区'"
                style="width:100%"
                :disabled="!formHasCampus"
              >
                <el-option v-for="t in timeOptions" :key="t.Id" :label="t.TimeName" :value="t.Id">
                  <span>{{ t.TimeName }}</span>
                  <span class="scs-time-opt-range">{{ t.StartTime }}~{{ t.EndTime }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </section>

          <section class="scs-form-section">
            <header class="scs-form-section__head">
              <span class="scs-form-section__title">学生组成</span>
              <span class="scs-form-section__hint">班级与名单范围</span>
            </header>
            <el-form-item label="上课班级" prop="ClassId">
              <el-select
                v-model="editForm.ClassId"
                :placeholder="formHasCampus ? '请选择主班级' : '请先选择所属校区'"
                filterable
                clearable
                style="width:100%"
                @change="onClassSelected"
              >
                <el-option v-for="c in classOptions" :key="c.Id" :label="c.Name" :value="c.Id" />
              </el-select>
            </el-form-item>

            <el-form-item label="学生范围">
              <div class="scs-stu-seg" role="radiogroup">
                <button
                  type="button"
                  class="scs-stu-seg__btn"
                  :class="{ 'is-active': editForm.StudentType === 1 }"
                  @click="setStudentType(1)"
                >本班全体</button>
                <button
                  type="button"
                  class="scs-stu-seg__btn"
                  :class="{ 'is-active': editForm.StudentType === 2 }"
                  @click="setStudentType(2)"
                >本班部分</button>
                <button
                  type="button"
                  class="scs-stu-seg__btn"
                  :class="{ 'is-active': editForm.StudentType === 3 }"
                  @click="setStudentType(3)"
                >跨班/混合</button>
              </div>
            </el-form-item>

            <!-- 本班部分：按人员类型筛选待选学生；不选/清空表示全部（与旧数据兼容） -->
            <el-form-item label="人员类型" v-if="editForm.StudentType === 2">
              <el-select
                v-model="editForm.StudentLiveTypeIds"
                multiple
                clearable
                filterable
                placeholder="全部（不限制类型）"
                style="width:100%"
                @change="onPickerLiveTypeChangedFromForm"
              >
                <el-option
                  v-for="item in pickerLiveTypeList"
                  :key="item.LiveTypeId"
                  :label="item.LiveTypeName"
                  :value="pickerLiveTypeOptionValue(item)"
                />
              </el-select>
            </el-form-item>

            <el-form-item v-if="editForm.StudentType !== 1" label="选定学生" class="scs-form-item--pick">
              <div class="scs-pick-card">
                <div class="scs-pick-card__bar">
                  <div class="scs-pick-card__count">
                    <strong>{{ (editForm.SessionStudents || []).length }}</strong>
                    <span>人已选</span>
                  </div>
                  <div class="scs-pick-card__actions">
                    <el-button type="primary" size="small" icon="el-icon-user" @click="openStudentPicker">选择学生</el-button>
                    <el-button
                      v-if="editForm.SessionStudents && editForm.SessionStudents.length"
                      size="small"
                      plain
                      @click="editForm.SessionStudents = []"
                    >清空</el-button>
                  </div>
                </div>
                <p class="scs-pick-card__tip">{{ studentPickerTip }}</p>
                <div v-if="editForm.SessionStudents && editForm.SessionStudents.length" class="scs-pick-card__tags">
                  <el-tag
                    v-for="(s, idx) in sessionStudentPreview"
                    :key="'stu-' + s.StudentId + '-' + idx"
                    size="mini"
                    type="info"
                    effect="plain"
                    closable
                    @close="removeSessionStudent(idx)"
                  >{{ s.StudentName }}</el-tag>
                  <span v-if="(editForm.SessionStudents || []).length > sessionStudentPreview.length" class="ps-pick-more">
                    等 {{ editForm.SessionStudents.length }} 人
                  </span>
                </div>
                <div v-else class="scs-pick-card__empty">尚未选择学生，点击上方按钮从通讯录添加</div>
              </div>
            </el-form-item>
          </section>

          <section class="scs-form-section scs-form-section--soft">
            <header class="scs-form-section__head">
              <span class="scs-form-section__title">其它</span>
            </header>
            <el-form-item label="备注">
              <el-input v-model="editForm.Remark" type="textarea" :rows="2" placeholder="备注说明（可选）" />
            </el-form-item>
            <el-form-item label="排序号">
              <el-input-number v-model="editForm.SortOrder" :min="0" controls-position="right" />
            </el-form-item>
            <el-form-item label="状态">
              <el-switch v-model="editForm.IsEnable" active-text="启用" inactive-text="禁用" />
            </el-form-item>
          </section>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="formVisible = false">取消</el-button>
          <el-button type="primary" @click="formSubmit" :loading="formLoading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 配置默认教师弹窗：仅兜底，与周次/按日排班无关 -->
      <el-dialog title="配置默认教师（兜底）" :visible.sync="teacherDialogVisible" :close-on-click-modal="false" width="520px">
        <p class="teacher-tip">
          此处为<strong>静态兜底</strong>：仅当某日<strong>没有</strong>在「排班管理」里配置当日教师时，才使用这里的人选。<br>
          按周循环、按月导入、按日微调教师，请使用「排班管理」；<strong>此处不必、也无法按周次配置</strong>。
        </p>
        <div class="ps-pick-summary">
          <span>已选 <strong>{{ teacherList.length }}</strong> 人</span>
          <el-button type="primary" size="small" plain @click="openDefaultTeacherPicker">选择教职工</el-button>
          <el-button v-if="teacherList.length" type="text" size="small" @click="teacherList = []">清空</el-button>
        </div>
        <p class="ps-pick-tip">从通讯录选择，可多选；下方可调整展示顺序</p>
        <div v-for="(item, idx) in teacherList" :key="'def-t-' + idx" class="teacher-row">
          <el-tag size="small" type="primary" effect="plain" class="teacher-row__name">{{ item.TeacherName || '未命名' }}</el-tag>
          <span class="teacher-row__sort-label">顺序</span>
          <el-input-number v-model="item.SortOrder" :min="0" size="small" controls-position="right"
            style="width:100px;margin-right:8px"></el-input-number>
          <el-button type="danger" icon="el-icon-delete" size="small" circle @click="removeTeacher(idx)"></el-button>
        </div>
        <div v-if="!teacherList.length" class="muted-text" style="margin-top:8px">尚未选择默认教师</div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="teacherDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveTeachers" :loading="teacherLoading">保存</el-button>
        </div>
      </el-dialog>

      <!-- 统一通讯录选人：学生(家校多选) / 教职工(内部多选) -->
      <person-scope-picker-dialog
        :visible.sync="personPickerVisible"
        :directory-scope="personPickerScope"
        :show-scope-tabs="false"
        :multiple="true"
        :scope-department-id="getActiveSchoolIdForApi()"
        :title="personPickerTitle"
        :selected-people="personPickerSelectedPeople"
        :live-type-id="personPickerLiveTypeId"
        @confirm="onPersonPickerConfirm"
      />

      <!-- 排班管理弹窗：直接复用 SpecialCourseSchedule 的逻辑 -->
      <el-dialog :title="scheduleDialogTitle" :visible.sync="scheduleDialogVisible" width="860px" top="4vh"
        custom-class="schedule-dialog-compact" append-to-body :close-on-click-modal="false">
        <div class="schedule-dialog-body" v-if="scheduleDialogVisible">
          <el-tabs v-model="scheduleActiveTab" type="card" @tab-click="onScheduleTabChange">
            <!-- Tab1：周循环模板 -->
            <el-tab-pane label="周循环模板" name="weekTemplate">
              <div class="tab-content tab-content--week">
                <div class="week-template-bar">
                  <el-date-picker v-model="calendarMonth" type="month" placeholder="选择月份" value-format="yyyy-MM"
                    @change="onWeekTemplateMonthChange" class="calendar-month-picker" clearable size="small"></el-date-picker>
                  <el-button type="primary" plain size="mini" icon="el-icon-refresh"
                    @click="loadWeekTemplateLocks(true)">刷新</el-button>
                  <span class="week-template-bar__split"></span>
                  <el-button type="primary" size="mini" icon="el-icon-check" @click="saveWeekTemplate"
                    :loading="weekSaveLoading">保存模板</el-button>
                  <el-button type="success" size="mini" icon="el-icon-date"
                    @click="applyDialogVisible = true">应用到日期范围</el-button>
                </div>
                <div class="calendar-hint calendar-hint--bar calendar-hint--compact week-template-hint">
                  <i class="el-icon-info"></i>
                  <span>配置每周固定值班教师，循环复用；留空表示当天不排。所选月份内有「代调」落地时，锁定槽位不可删改。</span>
                </div>
                <el-table :data="weekTemplateRows" border class="week-table" size="mini">
                  <el-table-column label="星期" width="72" align="center">
                    <template slot-scope="scope"><strong>{{ scope.row.label }}</strong></template>
                  </el-table-column>
                  <el-table-column label="值班教师" min-width="280">
                    <template slot-scope="scope">
                      <div class="teacher-tag-row">
                        <div v-for="(t, ti) in scope.row.teachers" :key="ti" class="week-teacher-block">
                          <el-tag
                            :closable="!isWeekTemplateAdjustmentLocked(scope.row.dow, t)" size="mini"
                            @close="removeWeekTeacher(scope.$index, ti)">
                            {{ weekTemplateTagTeacherDisplay(scope.row.dow, t) }}
                            <span v-if="isWeekTemplateAdjustmentLocked(scope.row.dow, t)" class="calendar-v2-adjust-tag">代调</span>
                          </el-tag>
                          <div v-if="isWeekTemplateAdjustmentLocked(scope.row.dow, t)" class="week-lock-pair-hint">
                            <span class="week-lock-pair-item week-lock-pair-item--block">原：<strong>{{ weekTemplateOriginalLabel(t) }}</strong><span class="week-lock-pair-muted">（周模板）</span></span>
                          </div>
                          <div v-if="isWeekTemplateAdjustmentLocked(scope.row.dow, t)" class="week-lock-date-hint">
                            {{ formatWeekTemplateLockDates(scope.row.dow, t) }}
                          </div>
                        </div>
                        <el-button size="mini" type="text" icon="el-icon-plus"
                          @click="openAddTeacherWeek(scope.$index)">添加</el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>

            <!-- Tab2：月历排班 -->
            <el-tab-pane label="月历排班" name="calendar">
              <div class="tab-content tab-content--calendar">
                <div class="calendar-toolbar card-bar">
                  <el-date-picker v-model="calendarMonth" type="month" placeholder="选择月份" value-format="yyyy-MM"
                    @change="loadCalendarSchedule" class="calendar-month-picker" clearable size="small"></el-date-picker>
                  <div class="calendar-toolbar-actions">
                    <el-button type="primary" plain size="mini" icon="el-icon-refresh"
                      @click="loadCalendarSchedule(true)">刷新</el-button>
                    <el-button size="mini" icon="el-icon-upload2" @click="openScheduleImport">Excel 导入排班</el-button>
                  </div>
                </div>
                <div class="calendar-hint calendar-hint--bar calendar-hint--compact">
                  <i class="el-icon-info"></i>
                  <span>点击日期格设置当日排班；代调日展示<strong>原</strong>（周模板）与<strong>代</strong>（落地）教师。</span>
                </div>
                <div class="calendar-panel-v2">
                  <div class="calendar-v2-head">
                    <div class="calendar-v2-head-cell" v-for="d in weekLabels" :key="d">{{ d }}</div>
                  </div>
                  <div class="calendar-v2-body" v-loading="calendarLoading" element-loading-text="加载排班…">
                    <div v-for="(week, wi) in calendarWeeks" :key="wi" class="calendar-v2-week">
                      <div v-for="day in week" :key="day.dateStr" class="calendar-v2-day"
                        :class="{ 'is-other': day.isOtherMonth, 'is-today': day.isToday, 'is-weekend': day.isWeekend }"
                        @click="editDaySchedule(day)">
                        <div class="calendar-v2-day-num">{{ day.day }}</div>
                        <div class="calendar-v2-day-content">
                          <div
                            v-for="(t, ti) in day.teachers"
                            :key="ti"
                            :class="['calendar-v2-teacher', isAdjustmentSource(t) ? 'calendar-v2-teacher--adj' : '']"
                          >
                            <template v-if="isAdjustmentSource(t)">
                              <div class="calendar-v2-adj-card">
                                <div class="calendar-v2-adj-head">
                                  <span class="calendar-v2-adj-badge">代调</span>
                                </div>
                                <div class="calendar-v2-adj-body">
                                  <div class="calendar-v2-adj-row">
                                    <span class="calendar-v2-adj-k">原</span>
                                    <span class="calendar-v2-adj-name" :title="originalTeacherFromWeekTemplate(day, t)">{{
                                      originalTeacherFromWeekTemplate(day, t)
                                    }}</span>
                                  </div>
                                  <div class="calendar-v2-adj-row">
                                    <span class="calendar-v2-adj-k">代</span>
                                    <span
                                      class="calendar-v2-adj-name calendar-v2-adj-name--act"
                                      :title="scheduleRowSubstituteName(t)"
                                    >{{ scheduleRowSubstituteName(t) }}</span>
                                  </div>
                                </div>
                              </div>
                            </template>
                            <template v-else>
                              <span class="calendar-v2-teacher-name">{{ t.TeacherName }}</span>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-dialog>

      <!-- 应用模板到日期范围弹窗 -->
      <el-dialog title="应用周模板到日期范围" :visible.sync="applyDialogVisible" width="440px" append-to-body>
        <el-form :model="applyForm" label-width="110px">
          <el-form-item label="开始日期">
            <el-date-picker v-model="applyForm.startDate" type="date" value-format="yyyy-MM-dd" placeholder="选择开始日期"
              style="width:100%"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker v-model="applyForm.endDate" type="date" value-format="yyyy-MM-dd" placeholder="选择结束日期"
              style="width:100%"></el-date-picker>
          </el-form-item>
          <el-form-item label="冲突策略">
            <el-radio-group v-model="applyForm.overwrite">
              <el-radio :label="false">跳过已有排班</el-radio>
              <el-radio :label="true">覆盖已有排班</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="applyDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="applyTemplate" :loading="applyLoading">确认展开</el-button>
        </div>
      </el-dialog>

      <!-- 编辑某天排班 -->
      <el-dialog :title="editDayTitle" :visible.sync="editDayVisible" width="550px" top="12vh"
        custom-class="edit-day-dialog" append-to-body :close-on-click-modal="false">
        <p class="edit-day-dialog-sub">
          从通讯录选择教师并设置展示顺序；无需排班时可删除全部行后保存，或使用「清除当日排班」。
          <span v-if="editDayHasAdjustmentRecord" class="danger-text">（代调课行已锁定，不可修改或删除；可调整其他教师）</span>
        </p>
        <div class="ps-pick-summary" style="margin-bottom:10px">
          <span>已选 <strong>{{ editDayTeachers.length }}</strong> 人</span>
          <el-button type="primary" size="small" plain @click="openEditDayTeacherPicker">选择教职工</el-button>
        </div>
        <div class="edit-day-list">
          <div v-for="(t, idx) in editDayTeachers" :key="'day-t-' + idx" class="edit-day-row">
            <span class="edit-day-row__badge">{{ idx + 1 }}</span>
            <span class="edit-day-row__name" :title="t.TeacherName">{{ t.TeacherName || '未命名' }}</span>
            <span class="edit-day-row__sort-label">顺序</span>
            <el-input-number v-model="t.SortOrder" :min="0" size="small" controls-position="right"
              class="edit-day-row__sort-input" :disabled="isAdjustmentSource(t)"></el-input-number>
            <el-tag v-if="isAdjustmentSource(t)" type="warning" size="mini" class="edit-day-row__lock-tag">代调锁定</el-tag>
            <el-button type="danger" icon="el-icon-delete" size="small" circle class="edit-day-row__del"
              :disabled="isAdjustmentSource(t)" @click="editDayTeachers.splice(idx, 1)"></el-button>
          </div>
        </div>
        <div v-if="!editDayTeachers.length" class="muted-text">尚未选择当日教师</div>
        <div slot="footer" class="edit-day-dialog-footer">
          <el-button type="danger" plain icon="el-icon-delete" :loading="dayClearLoading"
            :disabled="editDayHasAdjustmentRecord" @click="clearDayScheduleFromDialog">清除当日排班</el-button>
          <div class="edit-day-dialog-footer__right">
            <el-button @click="editDayVisible = false">取消</el-button>
            <el-button type="primary" icon="el-icon-check" @click="submitDaySchedule"
              :loading="dayLoading">保存</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- Excel 导入每日排班弹窗 (优化为 Tab 模式) -->
      <el-dialog title="Excel 导入每日排班" :visible.sync="importDialogVisible" width="600px" append-to-body
        :close-on-click-modal="false" custom-class="batch-import-dialog">
        <el-tabs v-model="scheduleImportActiveTab" type="border-card" class="import-export-tabs">
          <!-- Tab 1: 下载模板 -->
          <el-tab-pane label="下载导入模板" name="download">
            <div class="tab-pane-content">
              <div class="upload-config-card" style="text-align: center; padding: 40px 20px;">
                <i class="el-icon-document" style="font-size: 48px; color: var(--btn-primary, #2563eb); margin-bottom: 20px;"></i>
                <p style="font-size: 14px; color: #606266; margin-bottom: 20px;">
                  系统将生成 <strong>{{ calendarMonth }}</strong> 的每日日期行，并自动填入现有排班。
                </p>
                <el-button type="primary" icon="el-icon-download" @click="downloadTemplate"
                  style="width: 200px;">生成并下载模板</el-button>
              </div>
              <div class="step-tip">
                <i class="el-icon-info"></i>
                <span>提示：只需在 Excel 中填写或修改教师姓名，然后切换到“上传”页签导入。</span>
              </div>
            </div>
          </el-tab-pane>

          <!-- Tab 2: 上传导入 -->
          <el-tab-pane label="上传填写好的文件" name="upload">
            <div class="tab-pane-content">
              <div class="upload-config-card">
                <div class="config-row">
                  <span class="config-label">冲突策略</span>
                  <el-radio-group v-model="importForm.overwrite" size="small">
                    <el-radio-button :label="false">跳过已有</el-radio-button>
                    <el-radio-button :label="true">覆盖已有</el-radio-button>
                  </el-radio-group>
                </div>
                <div class="upload-area">
                  <el-upload ref="uploadRef" action="" :auto-upload="false" :limit="1" accept=".xlsx,.xls"
                    :on-change="onFileChange" :on-remove="onFileRemove" drag>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将填写好的排班文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">格式说明：第一列为日期，第二列为教师姓名</div>
                  </el-upload>
                </div>
                <div class="import-action-bar">
                  <el-button type="primary" size="medium" @click="submitImport" :loading="importLoading"
                    :disabled="!importFile" icon="el-icon-check" style="width: 100%">
                    开始执行导入
                  </el-button>
                </div>
              </div>
            </div>
          </el-tab-pane>

          <!-- Tab 3: 导入结果 -->
          <el-tab-pane label="导入结果" name="result" v-if="importResult">
            <div class="tab-pane-content">
              <div class="result-summary-cards">
                <div class="summary-card success">
                  <div class="num">{{ importResult.importCount || 0 }}</div>
                  <div class="label">成功导入条数</div>
                </div>
                <div class="summary-card clear">
                  <div class="num">{{ importResult.clearedDayCount || 0 }}</div>
                  <div class="label">有排班→空（天数）</div>
                </div>
                <div class="summary-card error" :class="{ active: importResult.errors && importResult.errors.length }">
                  <div class="num">{{ (importResult.errors && importResult.errors.length) || 0 }}</div>
                  <div class="label">失败/异常条数</div>
                </div>
              </div>

              <div v-if="importResult.errors && importResult.errors.length" class="result-detail-area">
                <div class="detail-header">
                  <i class="el-icon-warning-outline"></i>
                  <span>异常明细清单</span>
                </div>
                <el-scrollbar class="error-detail-scroll">
                  <div class="error-list-v2">
                    <div v-for="(e, i) in importResult.errors" :key="i" class="error-item-v2">
                      <span class="error-index">{{ i + 1 }}</span>
                      <span class="error-text">{{ e }}</span>
                    </div>
                  </div>
                </el-scrollbar>
              </div>

              <div v-else class="result-success-tip">
                <i class="el-icon-success"></i>
                <p>恭喜！全天排班已成功导入。</p>
              </div>

              <div class="result-footer">
                <el-button type="primary" size="medium" @click="scheduleImportActiveTab = 'upload'"
                  plain>继续导入其他文件</el-button>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div slot="footer" class="dialog-footer">
          <el-button @click="importDialogVisible = false" size="small">关 闭</el-button>
        </div>
      </el-dialog>

      <!-- 周模板矩阵导入弹窗 -->
      <el-dialog title="周模板矩阵导入" :visible.sync="batchImportWeekVisible" width="650px" custom-class="batch-import-dialog"
        :close-on-click-modal="false">
        <el-tabs v-model="importExportActiveTab" type="border-card" class="import-export-tabs">
          <!-- Tab 1: 下载模板 -->
          <el-tab-pane label="下载导入模板" name="export">
            <div class="tab-pane-content">
              <div class="class-selector-card">
                <div class="selector-header">
                  <div class="header-left">
                    <i class="el-icon-s-order"></i>
                    <span class="label">选择需要排班的班次</span>
                  </div>
                  <el-checkbox :indeterminate="isImportClassIndeterminate" v-model="checkAllImportClasses"
                    @change="handleCheckAllImportClasses">全选</el-checkbox>
                </div>
                <el-scrollbar class="selector-body">
                  <el-checkbox-group v-model="selectedImportClassIds" @change="handleCheckedImportClassesChange">
                    <div v-for="s in list" :key="s.Id" class="class-item">
                      <el-checkbox :label="s.Id">{{ s.SessionName }}</el-checkbox>
                    </div>
                  </el-checkbox-group>
                </el-scrollbar>
                <div class="selector-footer">
                  <el-button type="primary" icon="el-icon-download" @click="downloadBatchWeekTemplate"
                    :disabled="!selectedImportClassIds.length" style="width: 100%">
                    生成并下载 Excel 模板
                  </el-button>
                </div>
              </div>
              <div class="step-tip">
                <i class="el-icon-info"></i>
                <span>提示：第一列为班次名称（请勿修改，与系统全称一致）；列为「星期一」至「星期日」，每行班次已对应固定时段，在对应星期列填写教师姓名即可。</span>
              </div>
            </div>
          </el-tab-pane>

          <!-- Tab 2: 上传导入 -->
          <el-tab-pane label="上传填写好的文件" name="import">
            <div class="tab-pane-content">
              <div class="upload-config-card">
                <div class="config-row">
                  <span class="config-label">冲突策略</span>
                  <el-radio-group v-model="batchImportWeekOverwrite" size="small">
                    <el-radio-button :label="false">跳过已有模板</el-radio-button>
                    <el-radio-button :label="true">覆盖已有模板</el-radio-button>
                  </el-radio-group>
                </div>
                <div class="upload-area">
                  <el-upload ref="batchWeekUpload" action="" :auto-upload="false" :limit="1" accept=".xlsx,.xls"
                    :on-change="onBatchWeekFileChange" :on-remove="onBatchWeekFileRemove" drag>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将填写好的文件拖到此处，或<em>点击上传</em></div>
                  </el-upload>
                </div>
                <div class="import-action-bar">
                  <el-button type="primary" size="medium" @click="submitBatchImportWeek"
                    :loading="batchImportWeekLoading" :disabled="!batchImportWeekFile" icon="el-icon-check"
                    style="width: 100%">
                    开始执行导入
                  </el-button>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <!-- Tab 3: 导入结果 -->
          <el-tab-pane label="导入结果" name="result" v-if="batchImportWeekResult">
            <div class="tab-pane-content">
              <div class="result-summary-cards">
                <div class="summary-card success">
                  <div class="num">{{ batchImportWeekResult.importCount || 0 }}</div>
                  <div class="label">成功导入条数</div>
                </div>
                <div class="summary-card error"
                  :class="{ active: batchImportWeekResult.errors && batchImportWeekResult.errors.length }">
                  <div class="num">{{ (batchImportWeekResult.errors && batchImportWeekResult.errors.length) || 0 }}
                  </div>
                  <div class="label">失败/异常条数</div>
                </div>
              </div>

              <div v-if="batchImportWeekResult.errors && batchImportWeekResult.errors.length"
                class="result-detail-area">
                <div class="detail-header">
                  <i class="el-icon-warning-outline"></i>
                  <span>失败明细清单</span>
                </div>
                <el-scrollbar class="error-detail-scroll">
                  <div class="error-list-v2">
                    <div v-for="(e, i) in batchImportWeekResult.errors" :key="i" class="error-item-v2">
                      <span class="error-index">{{ i + 1 }}</span>
                      <span class="error-text">{{ e }}</span>
                    </div>
                  </div>
                </el-scrollbar>
              </div>

              <div v-else class="result-success-tip">
                <i class="el-icon-success"></i>
                <p>恭喜！所有数据已全部成功导入。</p>
              </div>

              <div class="result-footer">
                <el-button type="primary" size="medium" @click="importExportActiveTab = 'import'"
                  plain>继续导入其他文件</el-button>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>

        <div slot="footer" class="dialog-footer">
          <el-button @click="batchImportWeekVisible = false" size="small">关 闭</el-button>
        </div>
      </el-dialog>

      <!-- 日历矩阵：多班次 × 自选日期范围，每周一行、日～六列 -->
      <el-dialog title="日历矩阵导入" :visible.sync="batchImportMonthVisible" width="680px" custom-class="batch-import-dialog"
        :close-on-click-modal="false">
        <el-tabs v-model="batchMonthActiveTab" type="border-card" class="import-export-tabs">
          <el-tab-pane label="下载导入模板" name="export">
            <div class="tab-pane-content">
              <div class="class-selector-card">
                <div class="selector-header">
                  <div class="header-left">
                    <i class="el-icon-s-order"></i>
                    <span class="label">选择需要排班的班次</span>
                  </div>
                  <el-checkbox :indeterminate="isImportMonthClassIndeterminate" v-model="checkAllImportMonthClasses"
                    @change="handleCheckAllImportMonthClasses">全选</el-checkbox>
                </div>
                <el-scrollbar class="selector-body">
                  <el-checkbox-group v-model="selectedImportMonthSessionIds" @change="handleCheckedImportMonthClassesChange">
                    <div v-for="s in list" :key="s.Id" class="class-item">
                      <el-checkbox :label="s.Id">{{ s.SessionName }}</el-checkbox>
                    </div>
                  </el-checkbox-group>
                </el-scrollbar>
                <div class="config-row batch-week-range-row">
                  <span class="config-label">日期范围</span>
                  <div class="batch-week-range-pickers">
                    <el-date-picker v-model="batchWeekRangeStart" type="date" placeholder="开始日期" value-format="yyyy-MM-dd"
                      style="width:150px" clearable></el-date-picker>
                    <span class="batch-week-range-sep">至</span>
                    <el-date-picker v-model="batchWeekRangeEnd" type="date" placeholder="结束日期" value-format="yyyy-MM-dd"
                      style="width:150px" clearable></el-date-picker>
                  </div>
                </div>
                <div class="selector-footer">
                  <el-button type="primary" icon="el-icon-download" @click="downloadBatchMonthTemplate"
                    :disabled="!selectedImportMonthSessionIds.length || !batchWeekRangeStart || !batchWeekRangeEnd" style="width: 100%">
                    生成并下载 Excel 模板
                  </el-button>
                </div>
              </div>
              <div class="step-tip">
                <i class="el-icon-info"></i>
                <span>布局：<strong>每周一行</strong>，首列<strong>本周日</strong>（该周星期日），依次为<strong>月份、日期范围、周次</strong>（与本周日对应，表头标为不可修改）、排班起始/排班结束、班次名称，右侧为<strong>星期日～星期六</strong>。导入以<strong>排班起始～排班结束</strong>裁剪有效自然日；区间外填教师会忽略并提示。请勿修改本周日及上述辅助列内容，以免与真实日期错位；请使用本页下载的模板。</span>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="上传填写好的文件" name="import">
            <div class="tab-pane-content">
              <div class="upload-config-card">
                <div class="config-row">
                  <span class="config-label">冲突策略</span>
                  <el-radio-group v-model="batchImportMonthOverwrite" size="small">                    
                    <el-radio-button :label="false">覆盖当日</el-radio-button>
                    <el-radio-button :label="true">追加写入</el-radio-button>
                  </el-radio-group>
                </div>
                <div class="upload-area">
                  <el-upload ref="batchMonthUpload" action="" :auto-upload="false" :limit="1" accept=".xlsx,.xls"
                    :on-change="onBatchMonthFileChange" :on-remove="onBatchMonthFileRemove" drag>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将填写好的文件拖到此处，或<em>点击上传</em></div>
                  </el-upload>
                </div>
                <div class="import-action-bar">
                  <el-button type="primary" size="medium" @click="submitBatchImportMonth"
                    :loading="batchImportMonthLoading" :disabled="!batchImportMonthFile" icon="el-icon-check"
                    style="width: 100%">
                    开始执行导入
                  </el-button>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="导入结果" name="result" v-if="batchImportMonthResult">
            <div class="tab-pane-content">
              <div class="result-summary-cards">
                <div class="summary-card success">
                  <div class="num">{{ batchImportMonthResult.importCount || 0 }}</div>
                  <div class="label">成功写入条数</div>
                </div>
                <div class="summary-card clear">
                  <div class="num">{{ batchImportMonthResult.clearedSlotCount || 0 }}</div>
                  <div class="label">有排班→空（档位数）</div>
                </div>
                <div class="summary-card error"
                  :class="{ active: batchImportMonthResult.errors && batchImportMonthResult.errors.length }">
                  <div class="num">{{ (batchImportMonthResult.errors && batchImportMonthResult.errors.length) || 0 }}</div>
                  <div class="label">失败/提示条数</div>
                </div>
              </div>
              <div v-if="batchImportMonthResult.errors && batchImportMonthResult.errors.length" class="result-detail-area">
                <div class="detail-header">
                  <i class="el-icon-warning-outline"></i>
                  <span>明细</span>
                </div>
                <el-scrollbar class="error-detail-scroll">
                  <div class="error-list-v2">
                    <div v-for="(e, i) in batchImportMonthResult.errors" :key="i" class="error-item-v2">
                      <span class="error-index">{{ i + 1 }}</span>
                      <span class="error-text">{{ e }}</span>
                    </div>
                  </div>
                </el-scrollbar>
              </div>
              <div v-else class="result-success-tip">
                <i class="el-icon-success"></i>
                <p>导入处理完成。</p>
              </div>
              <div class="result-footer">
                <el-button type="primary" size="medium" @click="batchMonthActiveTab = 'import'" plain>继续导入其他文件</el-button>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div slot="footer" class="dialog-footer">
          <el-button @click="batchImportMonthVisible = false" size="small">关 闭</el-button>
        </div>
      </el-dialog>

      <!-- 批量生成班次弹窗 -->
      <el-dialog title="批量生成班次" :visible.sync="batchGenVisible" width="600px" :close-on-click-modal="false">
        <el-form label-width="100px">
          <el-form-item label="所属校区">
            <el-select v-model="batchGenCampusId" placeholder="请先选择校区" style="width:100%" :clearable="false"
              @change="onBatchCampusChange">
              <el-option v-for="c in campusOptions" :key="c.Id" :label="c.Name" :value="c.Id" />
            </el-select>
            <div class="el-upload__tip">须先选校区；时间模板、班级均按该校过滤。通用时间模板生成的班次归属所选校区。</div>
          </el-form-item>
          <el-form-item label="选择时间模板">
            <el-checkbox-group v-model="batchGenTimeIds">
              <el-checkbox v-for="t in batchTimeOptions" :key="t.Id" :label="t.Id">{{ t.TimeName }}</el-checkbox>
            </el-checkbox-group>
            <div class="el-upload__tip" v-if="!batchTimeTipHasCampus">请先选择所属校区</div>
            <div class="el-upload__tip" v-else-if="!batchTimeOptions.length">该校区下暂无启用的时间模板</div>
          </el-form-item>
          <el-form-item label="选择班级">
            <div class="batch-gen-class-box">
              <el-checkbox :indeterminate="isClassIndeterminate" v-model="checkAllClasses"
                @change="handleCheckAllClasses">全选所有班级</el-checkbox>
              <el-scrollbar style="height: 250px; border: 1px solid #ebeef5; padding: 10px; margin-top: 5px;">
                <el-checkbox-group v-model="batchGenClassIds" @change="handleCheckedClassesChange">
                  <div v-for="c in classOptions" :key="c.Id"
                    style="width: 50%; display: inline-block; margin-bottom: 5px;">
                    <el-checkbox :label="c.Id">{{ c.Name }}</el-checkbox>
                  </div>
                </el-checkbox-group>
              </el-scrollbar>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="batchGenVisible = false">取消</el-button>
          <el-button type="primary" @click="submitBatchGenerate" :loading="batchGenLoading"
            :disabled="batchGenSubmitDisabled">开始生成</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import { getSpecialCourseTimeList, getSpecialCourseSessionList, saveSpecialCourseSession, deleteSpecialCourseSession, batchDeleteSpecialCourseSessions, getSessionTeachers, saveSessionTeachers, getWeekTemplate, saveWeekTemplate, applyWeekTemplate, getScheduleList, saveDaySchedule, deleteDaySchedule, downloadScheduleTemplate, importSchedule, batchImportWeekTemplate, downloadBatchWeekTemplate, downloadBatchMonthScheduleTemplate, batchImportMonthSchedule, batchGenerateSessions } from '../../api/modules/schedule-course';
import { getSubDepartmentList, getStudentLiveTypeList, getDepartmentType } from '../../api/modules/department'
import { getTeacherMasterList } from '../../api/modules/personnel'
import { getCampusList } from '../../api/modules/misc'
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'
import DepartmentPane from '../../components/DepartmentPane'
import PersonScopePickerDialog from '../../components/PersonScopePickerDialog'
import { normalizeDeptId, deptIdsEqual } from '../../utils/deptCascaderProps'

const defaultForm = () => ({
  Id: 0,
  DepartmentId: 0,
  CampusId: null,
  SpecialCourseTimeId: '',
  /** 列表接口回填，用于关联时间下拉缺项时展示名称 */
  SpecialCourseTimeName: '',
  SessionName: '',
  StudentType: 1,
  ClassId: null,
  ClassName: '',
  Remark: '',
  SortOrder: 0,
  IsEnable: true,
  SessionStudents: [],
  selectedUserIds: [],
  /** 本班部分：人员类型 LiveTypeId，空=不限（与后端 StudentLiveTypeId 对应） */
  StudentLiveTypeId: '',
  /** 本班部分：人员类型多选（前端编辑态），提交时合并回 StudentLiveTypeId */
  StudentLiveTypeIds: []
})

export default {
  components: { Toolbar, DepartmentPane, PersonScopePickerDialog },
  data() {
    return {
      departmentId: 0,
      campusOptions: [],
      filters: { sessionName: '', timeId: null, isEnable: null },
      searchList: [
        { label: '班次名称', key: 'sessionName', width: '150px', initValue: '' },
        {
          label: '状态', key: 'isEnable', type: 'select', width: '120px', clearable: true, initValue: null,
          options: [{ label: '启用', value: true }, { label: '禁用', value: false }]
        }
      ],
      list: [],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      buttonList: [],
      currentRow: null,
      /** 左侧组织树最近一次点击的节点 data / el-tree node，新增班次时用于带出校区与班级 */
      lastTreeData: null,
      lastTreeNode: null,
      multipleSelection: [],
      timeOptions: [],
      batchTimeOptions: [],
      /** 当前机构下的班级（子部门），与任教管理等页面一致 */
      classOptions: [],

      // 排班管理弹窗相关
      scheduleDialogVisible: false,
      scheduleDialogTitle: '排班管理',
      scheduleActiveTab: 'weekTemplate',
      scheduleSessionId: null,
      weekTemplateRows: [1, 2, 3, 4, 5, 6, 7].map(i => ({ dow: i, label: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'][i - 1], teachers: [] })),
      weekSaveLoading: false,
      applyDialogVisible: false,
      applyLoading: false,
      applyForm: { startDate: '', endDate: '', overwrite: false },
      addWeekTeacherRowIdx: -1,
      /** 日排班代调落地(SourceType=4)按「星期1-7_SortOrder」汇总后的键列表，用于周模板禁止删改对应槽位 */
      weekTemplateLockedKeyList: [],
      /** 与 weekTemplateLockedKeyList 对应：key -> 该槽位在本扫描区间内的代调落地日期 yyyy-MM-dd（已排序去重） */
      weekTemplateLockDatesByKey: {},
      /** 同上 key：日排 SourceType=4 行上的实际值班教师名（去重，与月历代调格展示一致） */
      weekTemplateLockSubstituteNamesByKey: {},
      calendarMonth: '',
      calendarWeeks: [],
      calendarLoading: false,
      weekLabels: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      editDayVisible: false,
      editDayTitle: '',
      editDayDate: null,
      editDayTeachers: [],
      editDayHasAdjustmentRecord: false,
      dayLoading: false,
      dayClearLoading: false,
      importDialogVisible: false,
      importLoading: false,
      importFile: null,
      importForm: { overwrite: false },
      importResult: null,
      scheduleImportActiveTab: 'download',

      batchImportWeekVisible: false,
      batchImportWeekLoading: false,
      batchImportWeekFile: null,
      batchImportWeekOverwrite: false,
      batchImportWeekResult: null,
      importResultActiveTab: 'success', // 'success' 或 'error'

      batchGenVisible: false,
      batchGenLoading: false,
      batchGenCampusId: null,
      batchGenClassIds: [],
      batchGenTimeIds: [],
      checkAllClasses: false,
      isClassIndeterminate: false,

      // 周模板矩阵导入相关
      selectedImportClassIds: [],
      checkAllImportClasses: false,
      isImportClassIndeterminate: false,
      importExportActiveTab: 'export',

      batchImportMonthVisible: false,
      batchMonthActiveTab: 'export',
      batchWeekRangeStart: '',
      batchWeekRangeEnd: '',
      selectedImportMonthSessionIds: [],
      checkAllImportMonthClasses: false,
      isImportMonthClassIndeterminate: false,
      batchImportMonthFile: null,
      batchImportMonthOverwrite: false,
      batchImportMonthLoading: false,
      batchImportMonthResult: null,

      formVisible: false,
      formTitle: '新增班次',
      formLoading: false,
      editForm: defaultForm(),
      formRules: {
        SessionName: [{ required: true, message: '请输入班次名称', trigger: 'blur' }],
        CampusId: [{
          validator: (rule, value, callback) => {
            if (!normalizeDeptId(value)) return callback(new Error('请选择所属校区'))
            callback()
          },
          trigger: 'change'
        }],
        SpecialCourseTimeId: [{ required: true, message: '请选择关联时间', trigger: 'change' }],
        ClassId: [{ required: true, message: '请选择上课班级', trigger: 'change' }]
      },

      /** 本班部分：人员类型下拉（getStudentLiveTypeList） */
      pickerLiveTypeList: [],

      /** 统一通讯录选人：student | defaultTeacher | weekTeacher | editDayTeacher */
      personPickerVisible: false,
      personPickerMode: 'student',
      personPickerSelectedPeople: [],

      teacherDialogVisible: false,
      teacherLoading: false,
      /** 排班姓名回退缓存（不再用于扁平下拉） */
      teacherOptions: [],
      teacherSessionId: null,
      teacherList: []
    }
  },
  computed: {
    /** 批量弹窗是否已选校区（用于时间模板区域提示） */
    batchTimeTipHasCampus() {
      return !!normalizeDeptId(this.batchGenCampusId)
    },
    batchGenSubmitDisabled() {
      if (!normalizeDeptId(this.batchGenCampusId)) return true
      return !this.batchGenClassIds.length || !this.batchGenTimeIds.length
    },
    /** 表单是否已选所属校区（normalizeDeptId 返回字符串，勿用 Number.isFinite） */
    formHasCampus() {
      return !!normalizeDeptId(this.editForm.CampusId)
    },
    sessionStudentPreview() {
      return (this.editForm.SessionStudents || []).slice(0, 8)
    },
    personPickerScope() {
      return this.personPickerMode === 'student' ? 'teaching' : 'internal'
    },
    personPickerTitle() {
      if (this.personPickerMode === 'student') return '选择学生'
      return '选择教职工'
    },
    /** 本班部分且已选人员类型时，通讯录按类型过滤（逗号分隔） */
    personPickerLiveTypeId() {
      if (this.personPickerMode !== 'student' || this.editForm.StudentType !== 2) return ''
      return this.parseLiveTypeIds(this.editForm.StudentLiveTypeIds).join(',')
    },
    studentPickerTip() {
      if (this.editForm.StudentType === 2 && this.personPickerLiveTypeId) {
        return '从通讯录选择；名单仅含上方已选人员类型'
      }
      return '从通讯录选择，可多选'
    }
  },
  watch: {
    /** 打开班次表单且为部分/混合时预拉人员类型，便于本班部分表单项直接展示下拉 */
    formVisible(val) {
      if (val && (this.editForm.StudentType === 2 || this.editForm.StudentType === 3)) {
        this.loadPickerLiveTypeOptions()
      }
    }
  },
  methods: {
    /** 获取顶部学校 ID，供学校范围接口使用并保留 long 字符串精度。 */
    getActiveSchoolIdForApi() {
      const candidates = [
        this.$store.state.activeSchoolId,
        window.localStorage.getItem('activeSchoolId')
      ]
      return candidates.find(id => /^\d+$/.test(String(id || '')) && String(id) !== '0') || ''
    },
    /** 班次列表应到人数：优先后端 RosterStudentCount（与本班部分人员类型∪名单一致），否则退回 SessionStudents 条数 */
    sessionRosterCount(row) {
      const raw = row.rosterStudentCount != null ? row.rosterStudentCount : row.RosterStudentCount
      const n = Number(raw)
      if (Number.isFinite(n) && n >= 0) return n
      return (row.SessionStudents || []).length
    },
    /** 列表“学生组成”展示文案 */
    studentScopeLabel(row) {
      const total = this.sessionRosterCount(row)
      if (row.StudentType === 1) return '本班全体'
      if (row.StudentType === 2) {
        const liveTypeName = row.studentLiveTypeName || row.StudentLiveTypeName || ''
        return liveTypeName ? `本班部分·${liveTypeName}（${total}人）` : `本班部分（${total}人）`
      }
      return `跨班/混合（${total}人）`
    },
    treeNodeClick(data, node) {
      this.departmentId = data.value
      this.lastTreeData = data || null
      this.lastTreeNode = node || null
      this.page = 1
      this.loadCampusOptions()
      this.handleQuery()
    },
    /** 从左侧树节点向上找校区 Id（字符串）；找不到则返回空串。 */
    resolveCampusIdFromTreeNode(node) {
      let n = node
      while (n && n.data) {
        const t = String((n.data.DeptOrgType != null ? n.data.DeptOrgType : n.data.deptOrgType) || '').toLowerCase()
        if (t === 'campus') {
          return normalizeDeptId(n.data.value != null ? n.data.value : n.data.Id)
        }
        n = n.parent
      }
      return ''
    },
    /** 将校区 Id 对齐到 campusOptions 的 value 类型，保证 el-select 能回显。 */
    pickCampusOptionValue(campusId) {
      const id = normalizeDeptId(campusId)
      if (!id) return null
      const hit = (this.campusOptions || []).find(c => deptIdsEqual(c.Id, id))
      return hit ? hit.Id : id
    },
    /**
     * 新增班次时带出左侧树上下文：校区（树节点/唯一校区）与班级。
     * 有校区后才会请求关联时间列表接口。
     */
    applyTreeContextToAddForm() {
      const data = this.lastTreeData
      const deptType = String((data && (data.DeptOrgType || data.deptOrgType)) || '').toLowerCase()
      let campusId = normalizeDeptId(this.editForm.CampusId)
      if (!campusId) {
        if (deptType === 'campus' && data) {
          campusId = normalizeDeptId(data.value)
        } else {
          campusId = this.resolveCampusIdFromTreeNode(this.lastTreeNode)
        }
        if (!campusId && this.campusOptions.length === 1) {
          campusId = normalizeDeptId(this.campusOptions[0].Id)
        }
        const picked = this.pickCampusOptionValue(campusId)
        if (picked != null) this.editForm.CampusId = picked
      }
      if (deptType === 'class' && data) {
        const classId = normalizeDeptId(data.value)
        if (classId) {
          this.editForm.ClassId = classId
          this.editForm.ClassName = data.label || data.Name || ''
        }
      }
    },
    /**
     * 拉取当前学校下全部校区。左侧树可能是年级/班级等非学校节点，Campus/GetList 会只返回一条或空，
     * 导致编辑班次时校区下拉无匹配项、界面显示原始 ID；故先 GetDepartmentType 解析到学校再拉校区。
     */
    loadCampusOptions() {
      if (!this.departmentId) {
        this.campusOptions = []
        return Promise.resolve()
      }
      return getDepartmentType({ id: this.departmentId }).then(typeRes => {
        let schoolId = this.departmentId
        const sch = typeRes.data && typeRes.data.response
        if (sch && sch.Id != null) schoolId = sch.Id
        return getCampusList({ page: 1, intPageSize: 999, departmentId: schoolId })
      }).then(res => {
        const r = res.data || res
        const raw = (r.success && r.response && r.response.data) ? r.response.data : []
        this.campusOptions = raw.map(c => ({
          Id: normalizeDeptId(c.Id),
          Name: c.Name
        })).filter(c => c.Id)
      }).catch(() => {
        return getCampusList({ page: 1, intPageSize: 999, departmentId: this.departmentId }).then(res => {
          const r = res.data || res
          const raw = (r.success && r.response && r.response.data) ? r.response.data : []
          this.campusOptions = raw.map(c => ({
            Id: normalizeDeptId(c.Id),
            Name: c.Name
          })).filter(c => c.Id)
        }).catch(() => { this.campusOptions = [] })
      })
    },
    /**
     * 特殊课程时间列表接口在 departmentId 为「班级」时会只返回与该班有关的时间，选项不全导致编辑时关联时间无法回显。
     * 与校区列表一致：解析到学校节点再请求。
     */
    resolveSchoolIdForApi() {
      const activeSchoolId = this.getActiveSchoolIdForApi()
      if (activeSchoolId) return Promise.resolve(activeSchoolId)
      if (!this.departmentId) return Promise.resolve(null)
      return getDepartmentType({ id: this.departmentId }).then(typeRes => {
        const sch = typeRes.data && typeRes.data.response
        if (sch && sch.Id != null) return sch.Id
        return this.departmentId
      }).catch(() => this.departmentId)
    },
    /** 编辑时若列表接口未包含当前校区，补一条选项以便 el-select 回显名称 */
    ensureCampusOptionForEditForm() {
      const id = normalizeDeptId(this.editForm.CampusId)
      if (!id) return
      if (!this.campusOptions.some(c => deptIdsEqual(c.Id, id))) {
        const name = this.editForm.CampusName || `校区（ID:${id}）`
        this.campusOptions = [{ Id: id, Name: name }, ...this.campusOptions]
      }
    },
    /** 编辑时当前关联时间不在下拉中（如左侧树在班级节点、或模板已禁用）时补一条以便回显 */
    ensureTimeOptionForEditForm() {
      const tid = Number(this.editForm.SpecialCourseTimeId)
      if (!Number.isFinite(tid) || tid <= 0) return
      if (!this.timeOptions.some(t => Number(t.Id) === tid)) {
        const name = this.editForm.SpecialCourseTimeName || `时间模板（ID:${tid}）`
        this.timeOptions = [{ Id: tid, TimeName: name, StartTime: '', EndTime: '' }, ...this.timeOptions]
      }
    },
    handleCurrentChange(val) {
      this.page = val
      this.handleQuery()
    },
    /** 每页条数变更时回到第一页并重新查询 */
    handleSizeChange(val) {
      this.pageSize = val
      this.page = 1
      this.handleQuery()
    },
    /** 批量生成弹窗：须先选校区，时间模板列表与编辑表单一致（该校区的模板 + 全校通用） */
    loadBatchTimeOptions() {
      if (!this.departmentId) {
        this.batchTimeOptions = []
        return
      }
      const campusId = normalizeDeptId(this.batchGenCampusId)
      if (!campusId) {
        this.batchTimeOptions = []
        return
      }
      this.resolveSchoolIdForApi().then(deptId => {
        if (!deptId) {
          this.batchTimeOptions = []
          return
        }
        return getSpecialCourseTimeList({
          departmentId: deptId,
          page: 1,
          pageSize: 500,
          isEnable: true,
          campusId
        }).then(res => {
          const result = res.data || res
          const raw = result.success ? (result.response.data || []) : []
          this.batchTimeOptions = raw.map(t => Object.assign({}, t, { Id: Number(t.Id) }))
        })
      }).catch(() => { this.batchTimeOptions = [] })
    },
    /** 编辑表单：须先选所属校区，再按校区拉取可选时间模板（始终按学校拉全量，避免左侧在班级节点时选项缺失） */
    loadFormTimeOptions() {
      if (!this.departmentId) {
        this.timeOptions = []
        return Promise.resolve()
      }
      const campusId = normalizeDeptId(this.editForm.CampusId)
      if (!campusId) {
        this.timeOptions = []
        return Promise.resolve()
      }
      return this.resolveSchoolIdForApi().then(deptId => {
        if (!deptId) {
          this.timeOptions = []
          return
        }
        const params = {
          departmentId: deptId,
          page: 1,
          pageSize: 500,
          isEnable: true,
          campusId
        }
        return getSpecialCourseTimeList(params).then(res => {
          const result = res.data || res
          const raw = result.success ? (result.response.data || []) : []
          this.timeOptions = raw.map(t => Object.assign({}, t, { Id: Number(t.Id) }))
        })
      }).catch(() => { this.timeOptions = [] })
    },
    onSessionCampusChange() {
      this.editForm.SpecialCourseTimeId = ''
      this.editForm.ClassId = null
      this.editForm.ClassName = ''
      this.editForm.SessionStudents = []
      this.loadFormTimeOptions()
      this.loadClassOptions('form')
    },
    /** 仅行政班节点：DeptOrgType 为 class（排除年级 grade、学段 period、校区 campus 等） */
    isClassDepartment(d) {
      return String((d && d.DeptOrgType) || '').toLowerCase() === 'class'
    },
    /**
     * 拉取行政班列表。form：以所选校区为根（须先选校区）；batch：有默认校区则以校区为根，否则以左侧机构为根。
     */
    loadClassOptions(mode = 'form') {
      let pid = 0
      if (mode === 'batch') {
        const batchCampus = normalizeDeptId(this.batchGenCampusId)
        if (!this.departmentId || !batchCampus) {
          this.classOptions = []
          return
        }
        pid = batchCampus
      } else {
        const campusId = normalizeDeptId(this.editForm.CampusId)
        if (!this.departmentId || !campusId) {
          this.classOptions = []
          return
        }
        pid = campusId
      }
      getSubDepartmentList({ pid }).then(res => {
        const result = res.data || res
        const raw = (result.response || []).slice()
        let list = raw.filter(d => this.isClassDepartment(d))
        list.sort((a, b) => (a.Name || '').localeCompare(b.Name || '', 'zh-CN'))
        const cid = this.editForm.ClassId
        if (mode === 'form' && cid && !list.some(x => x.Id === cid)) {
          const hit = raw.find(x => x.Id === cid)
          // 班级不在当前校区活跃树时（如已毕业）仅作回显，不再用过期 ClassName 伪装为可选班
          if (hit && this.isClassDepartment(hit)) {
            list.unshift(hit)
          } else {
            list.unshift({
              Id: cid,
              Name: (hit && hit.Name) || this.editForm.ClassName || `班级（ID:${cid}）`,
              _stale: true
            })
          }
        }
        this.classOptions = list
        if (mode === 'form' && cid) {
          const live = list.find(x => x.Id === cid)
          if (live && live.Name) this.editForm.ClassName = live.Name
        }
      })
    },
    onBatchCampusChange() {
      this.batchGenTimeIds = []
      this.batchGenClassIds = []
      this.checkAllClasses = false
      this.isClassIndeterminate = false
      this.loadBatchTimeOptions()
      this.loadClassOptions('batch')
    },
    onClassSelected(classId) {
      if (!classId) {
        this.editForm.ClassName = ''
        return
      }
      const c = this.classOptions.find(x => x.Id === classId)
      this.editForm.ClassName = c ? c.Name : ''
      // 切换班级后，如果是本班部分，建议清空已选学生
      if (this.editForm.StudentType === 2) {
        this.editForm.SessionStudents = []
      }
    },
    /** 分段按钮切换学生范围（避免重复点当前项清空名单） */
    setStudentType(val) {
      if (this.editForm.StudentType === val) return
      this.editForm.StudentType = val
      this.onStudentTypeChange(val)
    },
    onStudentTypeChange(val) {
      // 切换学生范围类型时，清空已选学生名单，避免逻辑冲突
      this.editForm.SessionStudents = []
      this.editForm.StudentLiveTypeId = ''
      this.editForm.StudentLiveTypeIds = []
      if (val === 2 || val === 3) {
        this.loadPickerLiveTypeOptions()
      }
    },
    /** 解析人员类型字符串（支持逗号分隔） */
    parseLiveTypeIds(raw) {
      if (raw == null || raw === '') return []
      if (Array.isArray(raw)) {
        return Array.from(new Set(raw.map(v => String(v).trim()).filter(Boolean)))
      }
      return Array.from(new Set(String(raw).split(',').map(v => v.trim()).filter(Boolean)))
    },
    /** 人员类型选项 value，与接口 LiveTypeId 一致 */
    pickerLiveTypeOptionValue(item) {
      if (!item || item.LiveTypeId == null || item.LiveTypeId === '') return ''
      return String(item.LiveTypeId)
    },
    /** 根据左侧机构加载人员类型列表（GetStudentLiveType） */
    loadPickerLiveTypeOptions() {
      if (!this.departmentId) {
        this.pickerLiveTypeList = []
        return
      }
      getStudentLiveTypeList({ id: this.departmentId }).then(res => {
        this.pickerLiveTypeList = (res.data && res.data.response) ? res.data.response : []
      }).catch(() => { this.pickerLiveTypeList = [] })
    },
    /** 本班部分：切换人员类型后清空已选学生，避免仍保留未按类型过滤的旧名单 */
    onPickerLiveTypeChangedFromForm() {
      if (this.editForm.StudentType !== 2) return
      if (!(this.editForm.SessionStudents || []).length) return
      this.editForm.SessionStudents = []
      this.$message.info('人员类型已变更，已清空选定学生，请重新选择')
    },
    removeSessionStudent(idx) {
      this.editForm.SessionStudents.splice(idx, 1)
    },
    /** 打开通讯录选人（学生 / 默认教师 / 周模板 / 日排班） */
    openPersonPicker(mode, selectedPeople) {
      if (!this.getActiveSchoolIdForApi()) {
        this.$message.error('请先选择学校')
        return
      }
      this.personPickerMode = mode
      this.personPickerSelectedPeople = Array.isArray(selectedPeople) ? selectedPeople.slice() : []
      this.personPickerVisible = true
    },
    openStudentPicker() {
      if (!this.departmentId) { this.$message.error('请先选择机构'); return }
      const selected = (this.editForm.SessionStudents || []).map(s => ({
        id: s.StudentId,
        name: s.StudentName || ''
      }))
      this.openPersonPicker('student', selected)
    },
    openDefaultTeacherPicker() {
      const selected = (this.teacherList || [])
        .filter(t => t.TeacherId)
        .map(t => ({ id: t.TeacherId, name: t.TeacherName || '' }))
      this.openPersonPicker('defaultTeacher', selected)
    },
    openAddTeacherWeek(rowIdx) {
      this.addWeekTeacherRowIdx = rowIdx
      const row = this.weekTemplateRows[rowIdx]
      const selected = ((row && row.teachers) || [])
        .filter(t => t.TeacherId && !this.isWeekTemplateAdjustmentLocked(row.dow, t))
        .map(t => ({ id: t.TeacherId, name: t.TeacherName || '' }))
      this.openPersonPicker('weekTeacher', selected)
    },
    openEditDayTeacherPicker() {
      const selected = (this.editDayTeachers || [])
        .filter(t => t.TeacherId && !this.isAdjustmentSource(t))
        .map(t => ({ id: t.TeacherId, name: t.TeacherName || '' }))
      this.openPersonPicker('editDayTeacher', selected)
    },
    onPersonPickerConfirm(people) {
      const list = Array.isArray(people) ? people : (people ? [people] : [])
      if (this.personPickerMode === 'student') {
        this.editForm.SessionStudents = list.map(p => ({
          StudentId: p.id,
          StudentName: p.name || ''
        }))
        return
      }
      if (this.personPickerMode === 'defaultTeacher') {
        this.applyPickedTeachersToDefaultList(list)
        return
      }
      if (this.personPickerMode === 'weekTeacher') {
        this.applyPickedTeachersToWeekRow(list)
        return
      }
      if (this.personPickerMode === 'editDayTeacher') {
        this.applyPickedTeachersToEditDay(list)
      }
    },
    /** 通讯录多选结果写回默认教师列表，保留已有顺序号 */
    applyPickedTeachersToDefaultList(people) {
      const prevMap = {}
      ;(this.teacherList || []).forEach(t => {
        if (t.TeacherId != null) prevMap[String(t.TeacherId)] = t
      })
      let nextOrder = this.getNextTeacherSortOrder()
      this.teacherList = people.map(p => {
        const old = prevMap[String(p.id)]
        if (old) return Object.assign({}, old, { TeacherName: p.name || old.TeacherName || '' })
        const row = { TeacherId: p.id, TeacherName: p.name || '', SortOrder: nextOrder }
        nextOrder += 1
        return row
      })
    },
    /** 周模板某日：锁定代调槽位保留，其余按通讯录结果重建 */
    applyPickedTeachersToWeekRow(people) {
      const row = this.weekTemplateRows[this.addWeekTeacherRowIdx]
      if (!row) return
      const locked = (row.teachers || []).filter(t => this.isWeekTemplateAdjustmentLocked(row.dow, t))
      const lockedIds = new Set(locked.map(t => String(t.TeacherId)))
      let nextOrder = this.getNextWeekRowSortOrder({ teachers: locked })
      const added = []
      people.forEach(p => {
        if (lockedIds.has(String(p.id))) return
        if (added.some(t => String(t.TeacherId) === String(p.id))) return
        added.push({
          DayOfWeek: row.dow,
          TeacherId: p.id,
          TeacherName: p.name || '',
          SortOrder: nextOrder
        })
        nextOrder += 1
      })
      row.teachers = locked.concat(added)
    },
    /** 日排班：锁定代调行保留，其余按通讯录结果重建 */
    applyPickedTeachersToEditDay(people) {
      const locked = (this.editDayTeachers || []).filter(t => this.isAdjustmentSource(t))
      const lockedIds = new Set(locked.map(t => String(t.TeacherId)))
      const orders = locked.map(t => Number(t.SortOrder) || 0)
      let nextOrder = locked.length ? Math.max(...orders) + 1 : 0
      const added = []
      people.forEach(p => {
        if (lockedIds.has(String(p.id))) return
        if (added.some(t => String(t.TeacherId) === String(p.id))) return
        added.push({ TeacherId: p.id, TeacherName: p.name || '', SortOrder: nextOrder })
        nextOrder += 1
      })
      this.editDayTeachers = locked.concat(added)
    },
    handleQuery() {
      if (!this.departmentId) { this.$message.error('请先从左侧选择具体的机构/学校'); return }
      this.listLoading = true
      getSpecialCourseSessionList({
        departmentId: this.departmentId,
        page: this.page,
        pageSize: this.pageSize,
        ...this.filters
      })
        .then(res => {
          const result = res.data || res
          if (result.success) {
            this.list = result.response.data
            this.total = result.response.dataCount
          }
        })
        .finally(() => {
          this.listLoading = false
          this.currentRow = null
          this.multipleSelection = []
          this.$nextTick(() => this.$refs.table && this.$refs.table.clearSelection())
        })
    },
    callFunction(item) {
      this.filters = typeof item.search === 'object' ? item.search : { sessionName: item.search }
      this[item.Func] && this[item.Func](item)
    },
    onSessionSelectionChange(selection) {
      this.multipleSelection = selection
    },
    /**
     * 单击行：单选（清空其它勾选后再勾当前行），供工具栏编辑。
     * 批量删除请用左侧勾选框多选，不要依赖行点击累加。
     */
    selectCurrentRow(val) {
      if (!val) return
      this.currentRow = val
      this.$nextTick(() => {
        if (!this.$refs.table) return
        this.$refs.table.clearSelection()
        this.$refs.table.setCurrentRow(val)
        this.$refs.table.toggleRowSelection(val, true)
      })
    },
    handleAdd() {
      if (!this.departmentId) { this.$message.error('请先选择机构/学校'); return }
      this.formTitle = '新增班次'
      this.editForm = defaultForm()
      this.editForm.DepartmentId = this.departmentId
      this.loadCampusOptions().then(() => {
        this.applyTreeContextToAddForm()
        this.loadClassOptions('form')
        return this.loadFormTimeOptions()
      }).then(() => {
        this.formVisible = true
        this.$nextTick(() => { this.$refs.editForm && this.$refs.editForm.clearValidate() })
      })
    },
    handleEdit() {
      if (this.multipleSelection.length > 1) {
        this.$message.error('请只选择一行数据进行编辑')
        return
      }
      const row = this.multipleSelection.length === 1
        ? this.multipleSelection[0]
        : this.currentRow
      if (!row) { this.$message.error('请先选择一行数据'); return }
      this.formTitle = '编辑班次'
      this.editForm = Object.assign(defaultForm(), row)
      this.editForm.SpecialCourseTimeName = row.specialCourseTimeName || row.SpecialCourseTimeName || ''
      const stLt = row.studentLiveTypeId != null && row.studentLiveTypeId !== ''
        ? String(row.studentLiveTypeId)
        : (row.StudentLiveTypeId != null && row.StudentLiveTypeId !== '' ? String(row.StudentLiveTypeId) : '')
      this.editForm.StudentLiveTypeId = stLt
      this.editForm.StudentLiveTypeIds = this.parseLiveTypeIds(stLt)
      const tid = Number(this.editForm.SpecialCourseTimeId)
      this.editForm.SpecialCourseTimeId = Number.isFinite(tid) && tid > 0 ? tid : ''
      if (this.editForm.ClassId != null) {
        const cl = normalizeDeptId(this.editForm.ClassId)
        this.editForm.ClassId = cl || null
      }
      this.loadCampusOptions().then(() => {
        this.editForm.CampusId = this.pickCampusOptionValue(this.editForm.CampusId)
        this.ensureCampusOptionForEditForm()
        this.loadClassOptions('form')
        return this.loadFormTimeOptions()
      }).then(() => {
        this.ensureTimeOptionForEditForm()
        this.formVisible = true
        this.$nextTick(() => { this.$refs.editForm && this.$refs.editForm.clearValidate() })
      })
    },
    /** 工具栏删除：已勾选若干行时走批量删除；仅高亮当前行未勾选时删一条 */
    handleDel() {
      if (this.multipleSelection.length > 0) {
        this.handleBatchDel()
        return
      }
      const row = this.currentRow
      if (!row) {
        this.$message.error('请先勾选要删除的班次，或单击选中一行后再删除')
        return
      }
      this.$confirm('删除班次将同时删除其所有排班记录，确认继续？', '提示', { type: 'warning' }).then(() => {
        this.listLoading = true
        deleteSpecialCourseSession({ id: row.Id }).then(res => {
          const result = res.data || res
          if (result.success) {
            this.$message.success('删除成功')
            this.handleQuery()
          } else {
            this.$message.error(result.msg)
          }
          this.listLoading = false
        })
      })
    },
    handleBatchDel() {
      if (!this.multipleSelection.length) {
        this.$message.warning('请勾选要删除的班次')
        return
      }
      const n = this.multipleSelection.length
      this.$confirm(`确定删除选中的 ${n} 个班次吗？将同时删除其排班、默认教师及关联数据。`, '提示', { type: 'warning' })
        .then(() => {
          this.listLoading = true
          const ids = this.multipleSelection.map(r => r.Id)
          batchDeleteSpecialCourseSessions(ids).then(res => {
            const result = res.data || res
            if (result.success) {
              this.$message.success(result.msg || '删除成功')
              this.handleQuery()
            } else {
              this.$message.error(result.msg)
            }
            this.listLoading = false
          }).catch(() => { this.listLoading = false })
        })
        .catch(() => { })
    },
    formSubmit() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return
        if (this.editForm.StudentType !== 2) {
          this.editForm.StudentLiveTypeId = ''
          this.editForm.StudentLiveTypeIds = []
        } else {
          this.editForm.StudentLiveTypeId = this.parseLiveTypeIds(this.editForm.StudentLiveTypeIds).join(',')
        }
        const payload = Object.assign({}, this.editForm)
        delete payload.StudentLiveTypeIds
        this.formLoading = true
        saveSpecialCourseSession(payload).then(res => {
          const result = res.data || res
          if (result.success) {
            this.$message.success('保存成功')
            this.formVisible = false
            this.handleQuery()
          } else {
            this.$message.error(result.msg)
          }
          this.formLoading = false
        })
      })
    },

    /** 拉取教师主数据参数：班次必须先明确校区，禁止回退为整校教师。 */
    getTeacherMasterQueryParams(sessionRow) {
      const cid = normalizeDeptId(sessionRow && sessionRow.CampusId)
      if (!cid) return null
      return {
        page: 1,
        intPageSize: 9999,
        DepartmentId: this.getActiveSchoolIdForApi(),
        campusId: cid
      }
    },
    // 配置默认教师：通讯录多选，不再一次拉全校教师下拉
    openTeacherDialog(row) {
      if (!this.getActiveSchoolIdForApi()) {
        this.$message.error('请先选择学校')
        return
      }
      if (!normalizeDeptId(row && row.CampusId)) {
        this.$message.error('当前班次未设置校区，无法配置默认教师')
        return
      }
      this.teacherSessionId = row.Id
      this.teacherList = []
      getSessionTeachers({ sessionId: row.Id }).then(sRes => {
        const sResult = sRes.data || sRes
        this.teacherList = sResult.success
          ? (sResult.response || []).map(t => Object.assign({}, t))
          : []
        this.teacherDialogVisible = true
      }).catch(() => {
        this.teacherList = []
        this.$message.error('加载默认教师失败')
      })
    },
    /** 新增行排序号：在现有最大 SortOrder 基础上 +1，避免与「上一行」重复 */
    getNextTeacherSortOrder() {
      if (!this.teacherList.length) return 1
      const orders = this.teacherList.map(t => {
        const n = Number(t.SortOrder)
        return Number.isFinite(n) ? n : 0
      })
      return Math.max(...orders) + 1
    },
    removeTeacher(idx) {
      this.teacherList.splice(idx, 1)
    },
    saveTeachers() {
      if (this.teacherList.some(t => !t.TeacherId || t.TeacherId === 0)) {
        this.$message.error('请先通过通讯录选择教师')
        return
      }
      const ids = this.teacherList.map(t => String(t.TeacherId))
      if (new Set(ids).size !== ids.length) {
        this.$message.error('不能重复选择同一位教师')
        return
      }
      this.teacherLoading = true
      const payload = this.teacherList.map(t => ({
        ...t,
        TeacherId: t.TeacherId,
        TeacherName: t.TeacherName || ''
      }))
      saveSessionTeachers(this.teacherSessionId, payload).then(res => {
        const result = res.data || res
        if (result.success) {
          this.$message.success('保存成功')
          this.teacherDialogVisible = false
          this.handleQuery()
        } else {
          this.$message.error(result.msg)
        }
        this.teacherLoading = false
      }).catch(() => {
        this.teacherLoading = false
      })
    },

    /** 跳转全校/班级排班日历页（需在菜单中配置路由 SpecialCourse/SpecialCourseScheduleCalendar） */
    goScheduleCalendar() {
      this.$router.push({ path: '/SpecialCourse/SpecialCourseScheduleCalendar' })
    },

    goSchedule(row) {
      if (!row.Id) return
      this.scheduleSessionId = row.Id
      this.scheduleDialogTitle = `${row.SessionName || '班次'} - 排班管理`
      this.scheduleDialogVisible = true
      this.scheduleActiveTab = 'weekTemplate'

      const now = new Date()
      this.calendarMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
      // 清空月历缓存，避免再次进入仍显示上一班次/上次的格子数据，须等切换「月历排班」或刷新后重拉
      this.calendarWeeks = []

      this.loadWeekTemplate()
      // 按当前班次校区预加载教师（切换班次须重拉，避免沿用上一条班次的校区列表）
      const teacherParams = this.getTeacherMasterQueryParams(row)
      if (this.getActiveSchoolIdForApi() && teacherParams) {
        getTeacherMasterList(teacherParams).then(res => {
          this.teacherOptions = (res.data && res.data.response) ? res.data.response.slice() : []
        })
      } else {
        this.teacherOptions = []
      }
    },
    // ─── 排班管理弹窗内部逻辑 ───
    onScheduleTabChange(tab) {
      // 每次点到「月历排班」都重新拉取，避免关闭弹窗再进、或其它入口改过排班后仍显示旧数据
      if (tab.name === 'calendar') {
        this.loadCalendarSchedule()
      } else if (tab.name === 'weekTemplate') {
        this.loadWeekTemplateLocks()
      }
    },
    /** 与后端一致：周一=1 … 周日=7 */
    backendDayOfWeekFromDate(d) {
      let dow = d.getDay()
      if (dow === 0) dow = 7
      return dow
    },
    weekTemplateLockKey(dow, sortOrder) {
      return `${dow}_${Number(sortOrder)}`
    },
    isWeekTemplateAdjustmentLocked(dow, t) {
      const k = this.weekTemplateLockKey(dow, t && t.SortOrder)
      return this.weekTemplateLockedKeyList.indexOf(k) >= 0
    },
    computeWeekTemplateLocksFromScheduleList(rows) {
      const dateMap = {}
      const nameMap = {}
      const monthPrefix = this.calendarMonth ? String(this.calendarMonth).trim() : ''
      ;(rows || []).forEach(s => {
        if (Number(s.SourceType) !== 4) return
        const raw = s.Date
        const dateStr = raw ? String(raw).substring(0, 10) : ''
        if (!dateStr) return
        // 只认所选月份，避免整年里其它月份的代调落地出现在当前月视图
        if (monthPrefix && dateStr.substring(0, 7) !== monthPrefix) return
        const d = new Date(raw)
        if (Number.isNaN(d.getTime())) return
        const dow = this.backendDayOfWeekFromDate(d)
        const k = this.weekTemplateLockKey(dow, s.SortOrder)
        if (!dateMap[k]) dateMap[k] = []
        if (dateMap[k].indexOf(dateStr) < 0) dateMap[k].push(dateStr)
        let nm = (s.TeacherName && String(s.TeacherName).trim()) || ''
        if (!nm && s.TeacherId != null && s.TeacherId !== '') {
          const opt = this.teacherOptions.find(o => String(o.Id) === String(s.TeacherId))
          if (opt && opt.TeacherName) nm = String(opt.TeacherName).trim()
        }
        if (nm) {
          if (!nameMap[k]) nameMap[k] = []
          if (nameMap[k].indexOf(nm) < 0) nameMap[k].push(nm)
        }
      })
      Object.keys(dateMap).forEach(k => dateMap[k].sort())
      this.weekTemplateLockedKeyList = Object.keys(dateMap)
      this.weekTemplateLockDatesByKey = dateMap
      this.weekTemplateLockSubstituteNamesByKey = nameMap
    },
    weekTemplateOriginalLabel(t) {
      const n = t && t.TeacherName && String(t.TeacherName).trim()
      return n || '—'
    },
    weekTemplateSubstituteNamesJoin(dow, t) {
      const k = this.weekTemplateLockKey(dow, t && t.SortOrder)
      const names = this.weekTemplateLockSubstituteNamesByKey[k]
      if (!names || !names.length) return '—'
      return names.join('、')
    },
    /** 周模板首行标签：有代调锁定时显示日排代课教师，否则显示模板教师名 */
    weekTemplateTagTeacherDisplay(dow, t) {
      if (this.isWeekTemplateAdjustmentLocked(dow, t)) {
        const sub = this.weekTemplateSubstituteNamesJoin(dow, t)
        if (sub && sub !== '—') return sub
      }
      const n = t && t.TeacherName && String(t.TeacherName).trim()
      return n || '—'
    },
    /** 月历代调行：按星期+SortOrder 在周模板中取「原」值班姓名 */
    originalTeacherFromWeekTemplate(day, scheduleRow) {
      if (!day || !scheduleRow) return '—'
      const raw = day.date instanceof Date ? day.date : (day.dateStr ? new Date(String(day.dateStr).replace(/-/g, '/')) : null)
      if (!raw || Number.isNaN(raw.getTime())) return '—'
      const dow = this.backendDayOfWeekFromDate(raw)
      const so = Number(scheduleRow.SortOrder)
      const wrow = (this.weekTemplateRows || []).find(r => r.dow === dow)
      if (!wrow || !wrow.teachers || !wrow.teachers.length) return '—'
      const slot = wrow.teachers.find(x => Number(x.SortOrder) === so)
      const n = slot && slot.TeacherName && String(slot.TeacherName).trim()
      return n || '—'
    },
    /** 月历代调行：日排落地教师（代） */
    scheduleRowSubstituteName(row) {
      let n = row && row.TeacherName && String(row.TeacherName).trim()
      if (!n && row && row.TeacherId != null && row.TeacherId !== '') {
        const opt = this.teacherOptions.find(o => String(o.Id) === String(row.TeacherId))
        if (opt && opt.TeacherName) n = String(opt.TeacherName).trim()
      }
      return n || '—'
    },
    formatWeekTemplateLockDates(dow, t) {
      const k = this.weekTemplateLockKey(dow, t && t.SortOrder)
      const arr = this.weekTemplateLockDatesByKey[k]
      if (!arr || !arr.length) return ''
      const parts = arr.map(s => {
        const segs = s.split('-')
        if (segs.length < 3) return s
        const m = Number(segs[1])
        const d = Number(segs[2])
        return `${m}月${d}日`
      })
      if (parts.length <= 3) return `代调落地日：${parts.join('、')}`
      return `代调落地日：${parts.slice(0, 3).join('、')} 等共${parts.length}天`
    },
    onWeekTemplateMonthChange() {
      if (!this.calendarMonth || !String(this.calendarMonth).trim()) {
        this.weekTemplateLockedKeyList = []
        this.weekTemplateLockDatesByKey = {}
        this.weekTemplateLockSubstituteNamesByKey = {}
        return
      }
      this.loadWeekTemplateLocks()
    },
    loadWeekTemplateLocks(isManual) {
      if (!this.scheduleSessionId || !this.calendarMonth) {
        this.weekTemplateLockedKeyList = []
        this.weekTemplateLockDatesByKey = {}
        this.weekTemplateLockSubstituteNamesByKey = {}
        return
      }
      const [year, month] = this.calendarMonth.split('-').map(Number)
      if (!year || !month) {
        this.weekTemplateLockedKeyList = []
        this.weekTemplateLockDatesByKey = {}
        this.weekTemplateLockSubstituteNamesByKey = {}
        return
      }
      const monthText = String(month).padStart(2, '0')
      const lastDay = new Date(year, month, 0).getDate()
      const startDate = `${year}-${monthText}-01`
      const endDate = `${year}-${monthText}-${String(lastDay).padStart(2, '0')}`
      getScheduleList({ sessionId: this.scheduleSessionId, startDate, endDate }).then(res => {
        const result = res.data || res
        if (result.success) {
          this.computeWeekTemplateLocksFromScheduleList(result.response || [])
          if (isManual === true) this.$message.success('已按所选月份刷新代调锁定范围')
        } else {
          this.weekTemplateLockedKeyList = []
          this.weekTemplateLockDatesByKey = {}
          this.weekTemplateLockSubstituteNamesByKey = {}
        }
      }).catch(() => {
        this.weekTemplateLockedKeyList = []
        this.weekTemplateLockDatesByKey = {}
        this.weekTemplateLockSubstituteNamesByKey = {}
      })
    },
    loadWeekTemplate() {
      getWeekTemplate({ sessionId: this.scheduleSessionId }).then(res => {
        const result = res.data || res
        if (!result.success) return
        const list = result.response || []
        const DOW_LABELS = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
        this.weekTemplateRows = DOW_LABELS.map((label, i) => ({
          dow: i + 1,
          label,
          teachers: list.filter(t => t.DayOfWeek === i + 1).sort((a, b) => a.SortOrder - b.SortOrder)
        }))
        this.loadWeekTemplateLocks()
        if (this.scheduleActiveTab === 'calendar' && this.calendarMonth) {
          this.loadCalendarSchedule()
        }
      })
    },
    getNextWeekRowSortOrder(row) {
      if (!row || !row.teachers || !row.teachers.length) return 0
      const orders = row.teachers.map(t => {
        const n = Number(t.SortOrder)
        return Number.isFinite(n) ? n : 0
      })
      return Math.max(...orders) + 1
    },
    removeWeekTeacher(rowIdx, teacherIdx) {
      const row = this.weekTemplateRows[rowIdx]
      const t = row && row.teachers[teacherIdx]
      if (t && this.isWeekTemplateAdjustmentLocked(row.dow, t)) {
        this.$message.warning('该槽位在当月存在代调课落地日排班，不可从周模板删除')
        return
      }
      this.weekTemplateRows[rowIdx].teachers.splice(teacherIdx, 1)
    },
    saveWeekTemplate() {
      const payload = []
      this.weekTemplateRows.forEach(row => {
        row.teachers.forEach((t, i) => {
          payload.push({
            DayOfWeek: row.dow,
            TeacherId: t.TeacherId || 0,
            TeacherName: t.TeacherName || '',
            SortOrder: Number.isFinite(Number(t.SortOrder)) ? Number(t.SortOrder) : i
          })
        })
      })
      this.weekSaveLoading = true
      saveWeekTemplate(this.scheduleSessionId, payload).then(res => {
        const result = res.data || res
        result.success ? this.$message.success('模板保存成功') : this.$message.error(result.msg)
        this.weekSaveLoading = false
      })
    },
    applyTemplate() {
      if (!this.applyForm.startDate || !this.applyForm.endDate) {
        this.$message.error('请选择起止日期')
        return
      }
      this.applyLoading = true
      applyWeekTemplate({
        sessionId: this.scheduleSessionId,
        startDate: this.applyForm.startDate,
        endDate: this.applyForm.endDate,
        overwrite: this.applyForm.overwrite
      }).then(res => {
        const result = res.data || res
        if (result.success) {
          this.$message.success(result.msg || '展开成功')
          this.applyDialogVisible = false
          if (this.scheduleActiveTab === 'calendar') this.loadCalendarSchedule()
          else if (this.scheduleActiveTab === 'weekTemplate' && this.scheduleSessionId) this.loadWeekTemplateLocks()
        } else {
          this.$message.error(result.msg)
        }
        this.applyLoading = false
      })
    },
    loadCalendarSchedule(isManual) {
      if (!this.calendarMonth) return
      const [year, month] = this.calendarMonth.split('-').map(Number)
      const startDate = `${year}-${String(month).padStart(2, '0')}-01`
      const lastDayNum = new Date(year, month, 0).getDate()
      const endDate = `${year}-${String(month).padStart(2, '0')}-${lastDayNum}`

      this.calendarLoading = true
      getScheduleList({ sessionId: this.scheduleSessionId, startDate, endDate }).then(res => {
        const result = res.data || res
        const scheduleMap = {}
        if (result.success) {
          ; (result.response || []).forEach(s => {
            const key = (s.Date && String(s.Date).substring(0, 10)) || ''
            if (!key) return
            if (!scheduleMap[key]) scheduleMap[key] = []
            scheduleMap[key].push(s)
          })
          if (isManual === true) this.$message.success('排班数据已刷新')
        }

        // buildMonthWeeks 逻辑内联
        const weeks = []
        const firstDay = new Date(year, month - 1, 1)
        const lastDay = new Date(year, month, 0)
        const now = new Date()
        const ty = now.getFullYear(), tm = now.getMonth() + 1, td = now.getDate()
        let current = new Date(firstDay)
        current.setDate(current.getDate() - current.getDay())
        while (current <= lastDay || current.getDay() !== 0) {
          const week = []
          for (let i = 0; i < 7; i++) {
            const d = new Date(current), y = d.getFullYear(), m = d.getMonth() + 1, dayNum = d.getDate(), dow = d.getDay()
            const dateStr = `${y}-${String(m).padStart(2, '0')}-${String(dayNum).padStart(2, '0')}`
            week.push({
              date: d, day: dayNum, dateStr, teachers: scheduleMap[dateStr] || [],
              isOtherMonth: y !== year || m !== month,
              isToday: y === ty && m === tm && dayNum === td,
              isWeekend: dow === 0 || dow === 6
            })
            current.setDate(current.getDate() + 1)
          }
          weeks.push(week)
          if (current > lastDay && current.getDay() === 0) break
        }
        this.calendarWeeks = weeks
        if (result.success) this.loadWeekTemplateLocks()
      }).finally(() => { this.calendarLoading = false })
    },
    isAdjustmentSource(scheduleRow) {
      if (!scheduleRow) return false
      const sourceType = Number(scheduleRow.SourceType)
      return Number.isFinite(sourceType) && sourceType === 4
    },
    hasAdjustmentSchedule(day) {
      const teachers = (day && day.teachers) || []
      return teachers.some(t => this.isAdjustmentSource(t))
    },
    editDaySchedule(day) {
      this.editDayDate = day.dateStr
      this.editDayTitle = `排班设置 · ${day.dateStr}`
      const list = (day.teachers || []).map(t => Object.assign({}, t))
      this.editDayHasAdjustmentRecord = list.some(t => this.isAdjustmentSource(t))
      this.editDayTeachers = list
      this.editDayVisible = true
    },
    submitDaySchedule() {
      if (!this.editDayTeachers.length) {
        this.dayLoading = true
        saveDaySchedule(this.scheduleSessionId, this.editDayDate, []).then(res => {
          if (res.data.success) {
            this.$message.success('已清空当日排班')
            this.editDayVisible = false
            this.loadCalendarSchedule()
          }
          this.dayLoading = false
        })
        return
      }
      if (this.editDayTeachers.some(t => !t.TeacherId)) {
        this.$message.error('请选择教师')
        return
      }
      this.dayLoading = true
      saveDaySchedule(this.scheduleSessionId, this.editDayDate, this.editDayTeachers).then(res => {
        if (res.data.success) {
          this.$message.success('保存成功')
          this.editDayVisible = false
          this.loadCalendarSchedule()
        }
        this.dayLoading = false
      })
    },
    clearDayScheduleFromDialog() {
      if (this.editDayHasAdjustmentRecord) {
        this.$message.warning('该日包含代调课排班，不允许修改或删除')
        return
      }
      this.$confirm('确认清除当日全部排班？', '提示', { type: 'warning' }).then(() => {
        this.dayClearLoading = true
        deleteDaySchedule({ sessionId: this.scheduleSessionId, date: this.editDayDate }).then(res => {
          if (res.data.success) {
            this.$message.success('已清除')
            this.editDayVisible = false
            this.loadCalendarSchedule()
          }
          this.dayClearLoading = false
        })
      })
    },
    onFileChange(file) { this.importFile = file.raw },
    onFileRemove() { this.importFile = null },
    downloadTemplate() {
      if (!this.calendarMonth) { this.$message.error('请先在月历中选择月份'); return }
      const [year, month] = this.calendarMonth.split('-').map(Number)
      const startDate = `${year}-${String(month).padStart(2, '0')}-01`
      const lastDayNum = new Date(year, month, 0).getDate()
      const endDate = `${year}-${String(month).padStart(2, '0')}-${lastDayNum}`

      downloadScheduleTemplate({
        sessionId: this.scheduleSessionId,
        startDate,
        endDate
      }).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${this.scheduleDialogTitle}_排班模板.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    submitImport() {
      if (!this.importFile) { this.$message.error('请选择文件'); return }
      const formData = new FormData()
      formData.append('file', this.importFile)
      this.importLoading = true
      importSchedule(this.scheduleSessionId, this.importForm.overwrite, formData).then(res => {
        if (res.data.success) {
          this.importResult = res.data.response
          this.scheduleImportActiveTab = 'result' // 自动切换到结果页
          this.loadCalendarSchedule()
          if (res.data.msg) this.$message.success(res.data.msg)
        }
        this.importLoading = false
      })
    },
    openScheduleImport() {
      this.importFile = null
      this.importResult = null
      this.scheduleImportActiveTab = 'download'
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles()
      }
      this.importDialogVisible = true
    },
    // ─── 周模板矩阵导入逻辑 ───
    onBatchWeekFileChange(file) { this.batchImportWeekFile = file.raw },
    onBatchWeekFileRemove() { this.batchImportWeekFile = null },
    submitBatchImportWeek() {
      if (!this.batchImportWeekFile) { this.$message.error('请选择文件'); return }
      const formData = new FormData()
      formData.append('file', this.batchImportWeekFile)
      this.batchImportWeekLoading = true
      this.batchImportWeekResult = null
      batchImportWeekTemplate(this.departmentId, this.batchImportWeekOverwrite, formData).then(res => {
        const result = res.data || res
        if (result.success) {
          this.batchImportWeekResult = result.response
          this.$message.success('导入任务处理完成')
          this.importExportActiveTab = 'result' // 导入成功后自动切换到结果页
          this.$refs.batchWeekUpload && this.$refs.batchWeekUpload.clearFiles()
          this.batchImportWeekFile = null
        } else {
          this.$message.error(result.msg)
        }
        this.batchImportWeekLoading = false
      }).catch(() => { this.batchImportWeekLoading = false })
    },
    downloadBatchWeekTemplate() {
      if (!this.departmentId) { this.$message.error('请先选择机构/学校'); return }
      if (!this.selectedImportClassIds.length) { this.$message.error('请先选择需要导出的班次'); return }

      downloadBatchWeekTemplate({
        departmentId: this.departmentId,
        sessionIds: this.selectedImportClassIds.join(',')
      }).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', '周模板矩阵导入模板.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    openBatchImportWeek() {
      this.selectedImportClassIds = []
      this.checkAllImportClasses = false
      this.isImportClassIndeterminate = false
      this.batchImportWeekFile = null
      this.batchImportWeekResult = null
      this.importExportActiveTab = 'export'
      if (this.$refs.batchWeekUpload) {
        this.$refs.batchWeekUpload.clearFiles()
      }
      this.batchImportWeekVisible = true
    },
    handleCheckAllImportClasses(val) {
      this.selectedImportClassIds = val ? this.list.map(s => s.Id) : []
      this.isImportClassIndeterminate = false
    },
    handleCheckedImportClassesChange(value) {
      let checkedCount = value.length
      this.checkAllImportClasses = checkedCount === this.list.length
      this.isImportClassIndeterminate = checkedCount > 0 && checkedCount < this.list.length
    },
    openBatchImportMonth() {
      const now = new Date()
      const y = now.getFullYear()
      const m = String(now.getMonth() + 1).padStart(2, '0')
      const last = new Date(y, now.getMonth() + 1, 0).getDate()
      this.batchWeekRangeStart = `${y}-${m}-01`
      this.batchWeekRangeEnd = `${y}-${m}-${String(last).padStart(2, '0')}`
      this.selectedImportMonthSessionIds = []
      this.checkAllImportMonthClasses = false
      this.isImportMonthClassIndeterminate = false
      this.batchImportMonthFile = null
      this.batchImportMonthResult = null
      this.batchMonthActiveTab = 'export'
      if (this.$refs.batchMonthUpload) {
        this.$refs.batchMonthUpload.clearFiles()
      }
      this.batchImportMonthVisible = true
    },
    handleCheckAllImportMonthClasses(val) {
      this.selectedImportMonthSessionIds = val ? this.list.map(s => s.Id) : []
      this.isImportMonthClassIndeterminate = false
    },
    handleCheckedImportMonthClassesChange(value) {
      const checkedCount = value.length
      this.checkAllImportMonthClasses = checkedCount === this.list.length
      this.isImportMonthClassIndeterminate = checkedCount > 0 && checkedCount < this.list.length
    },
    onBatchMonthFileChange(file) { this.batchImportMonthFile = file.raw },
    onBatchMonthFileRemove() { this.batchImportMonthFile = null },
    downloadBatchMonthTemplate() {
      if (!this.departmentId) { this.$message.error('请先选择机构/学校'); return }
      if (!this.selectedImportMonthSessionIds.length) { this.$message.error('请先选择班次'); return }
      if (!this.batchWeekRangeStart || !this.batchWeekRangeEnd) { this.$message.error('请选择开始与结束日期'); return }
      if (this.batchWeekRangeEnd < this.batchWeekRangeStart) { this.$message.error('结束日期不能早于开始日期'); return }
      downloadBatchMonthScheduleTemplate({
        sessionIds: this.selectedImportMonthSessionIds.join(','),
        startDate: this.batchWeekRangeStart,
        endDate: this.batchWeekRangeEnd
      }).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `日历矩阵_${this.batchWeekRangeStart}_${this.batchWeekRangeEnd}.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    submitBatchImportMonth() {
      if (!this.batchImportMonthFile) { this.$message.error('请选择文件'); return }
      if (!this.departmentId) { this.$message.error('请先选择机构/学校'); return }
      const formData = new FormData()
      formData.append('file', this.batchImportMonthFile)
      this.batchImportMonthLoading = true
      this.batchImportMonthResult = null
      batchImportMonthSchedule(this.departmentId, this.batchImportMonthOverwrite, formData).then(res => {
        const result = res.data || res
        if (result.success) {
          this.batchImportMonthResult = result.response
          this.$message.success(result.msg || '日历矩阵导入完成')
          this.batchMonthActiveTab = 'result'
          if (this.$refs.batchMonthUpload) this.$refs.batchMonthUpload.clearFiles()
          this.batchImportMonthFile = null
          this.handleQuery()
        } else {
          this.$message.error(result.msg)
        }
        this.batchImportMonthLoading = false
      }).catch(() => { this.batchImportMonthLoading = false })
    },
    // ─── 批量生成班次逻辑 ───
    openBatchGenerate() {
      if (!this.departmentId) { this.$message.error('请先选择机构/学校'); return }
      this.batchGenClassIds = []
      this.batchGenTimeIds = []
      this.batchGenCampusId = null
      this.batchTimeOptions = []
      this.classOptions = []
      this.checkAllClasses = false
      this.isClassIndeterminate = false
      this.batchGenVisible = true
    },
    handleCheckAllClasses(val) {
      this.batchGenClassIds = val ? this.classOptions.map(c => c.Id) : []
      this.isClassIndeterminate = false
    },
    handleCheckedClassesChange(value) {
      let checkedCount = value.length
      this.checkAllClasses = checkedCount === this.classOptions.length
      this.isClassIndeterminate = checkedCount > 0 && checkedCount < this.classOptions.length
    },
    submitBatchGenerate() {
      const campusId = normalizeDeptId(this.batchGenCampusId)
      if (!campusId) {
        this.$message.error('请选择所属校区')
        return
      }
      this.batchGenLoading = true
      const data = {
        ClassIds: this.batchGenClassIds,
        TimeIds: this.batchGenTimeIds,
        CampusId: campusId
      }
      batchGenerateSessions(this.departmentId, data).then(res => {
        const result = res.data || res
        if (result.success) {
          this.$message.success(result.msg || '生成成功')
          this.batchGenVisible = false
          this.handleQuery()
        } else {
          this.$message.error(result.msg)
        }
        this.batchGenLoading = false
      }).catch(() => { this.batchGenLoading = false })
    }
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
  }
}
</script>

<style scoped>
/* 批量/矩阵：独占一行，避免与 Toolbar 内 el-col 浮动叠版；样式与右侧白卡片内分区一致 */
.special-course-batch-bar {
  clear: both;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  margin: 0 0 14px 0;
  background: #f5f7fa;
  border: 1px solid #e8ecf1;
  border-radius: 8px;
}

.special-course-batch-bar__label {
  font-size: 13px;
  font-weight: 600;
  color: #606266;
  margin-right: 4px;
  flex-shrink: 0;
}

.campus-form-tip {
  margin: 6px 0 0;
  font-size: 12px;
  color: #94a3b8;
  line-height: 1.45;
}

.scs-session-form {
  margin: 0;
}

.scs-form-section {
  margin-bottom: 14px;
  padding: 12px 14px 4px;
  background: #fff;
  border: 1px solid #e8ecf1;
  border-radius: 10px;
}

.scs-form-section--soft {
  background: #fafbfd;
}

.scs-form-section__head {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eef2f7;
}

.scs-form-section__title {
  font-size: 13px;
  font-weight: 700;
  color: #1f2a37;
  letter-spacing: 0.02em;
}

.scs-form-section__hint {
  font-size: 12px;
  color: #94a3b8;
}

.scs-session-form /deep/ .el-form-item {
  margin-bottom: 16px;
}

/* 校验文案为 absolute，需加大下间距，避免贴住下一行 */
.scs-session-form /deep/ .el-form-item.is-error {
  margin-bottom: 28px;
}

.scs-session-form /deep/ .el-form-item__error {
  padding-top: 4px;
  line-height: 1.2;
}

.scs-session-form /deep/ .el-form-item__label {
  color: #64748b;
  font-weight: 600;
  font-size: 13px;
}

.scs-time-opt-range {
  float: right;
  color: #94a3b8;
  font-size: 12px;
}

.scs-stu-seg {
  display: inline-flex;
  padding: 3px;
  border-radius: 10px;
  background: #eef2f7;
  border: 1px solid #e2e8f0;
  max-width: 100%;
}

.scs-stu-seg__btn {
  margin: 0;
  padding: 7px 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  font-size: 13px;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.scs-stu-seg__btn:hover {
  color: #1f2a37;
}

.scs-stu-seg__btn.is-active {
  background: #fff;
  color: #2563eb;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}

.scs-form-item--pick /deep/ .el-form-item__content {
  line-height: 1.4;
}

.scs-pick-card {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  padding: 10px 12px;
}

.scs-pick-card__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.scs-pick-card__count {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  color: #64748b;
  font-size: 13px;
}

.scs-pick-card__count strong {
  font-size: 20px;
  font-weight: 700;
  color: #1f2a37;
  line-height: 1;
}

.scs-pick-card__actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.scs-pick-card__tip {
  margin: 8px 0 0;
  font-size: 12px;
  color: #94a3b8;
  line-height: 1.4;
}

.scs-pick-card__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
  max-height: 88px;
  overflow-y: auto;
  padding-top: 2px;
}

.scs-pick-card__empty {
  margin-top: 10px;
  padding: 12px 10px;
  text-align: center;
  font-size: 12px;
  color: #94a3b8;
  background: #fff;
  border: 1px dashed #d8dee8;
  border-radius: 8px;
}


.text-muted {
  color: #c0c4cc;
}

.no-hover-btn:hover,
.no-hover-btn:focus,
.no-hover-btn:active {
  background: transparent !important;
  color: var(--btn-primary, #2563eb) !important;
  border-color: transparent !important;
  box-shadow: none !important;
}

.teacher-tip {
  color: #909399;
  font-size: 13px;
  margin-bottom: 12px;
}

.teacher-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 8px;
}

.teacher-row__name {
  min-width: 72px;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.teacher-row__sort-label {
  flex-shrink: 0;
  font-size: 12px;
  color: #909399;
}

.ps-pick-summary {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  color: #475569;
  font-size: 13px;
}

.ps-pick-tip {
  margin: 4px 0 8px;
  font-size: 12px;
  color: #94a3b8;
  line-height: 1.4;
}

.ps-pick-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ps-pick-more {
  color: #94a3b8;
  font-size: 12px;
  line-height: 24px;
}

.muted-text {
  color: #94a3b8;
  font-size: 12px;
}

/* ── 排班管理弹窗（收紧宽度与内边距，避免周模板两列被 90% 宽撑空） ── */
.schedule-dialog-compact {
  max-width: 96vw;
}

.schedule-dialog-compact /deep/ .el-dialog__header {
  padding: 12px 16px 8px;
}

.schedule-dialog-compact /deep/ .el-dialog__body {
  padding: 0;
  background: #f5f7fa;
  max-height: calc(100vh - 88px);
  overflow-y: auto;
}

.schedule-dialog-body {
  padding: 6px 12px 12px;
}

/* ── 矩阵导入弹窗优化 ── */
.batch-import-dialog /deep/ .el-dialog__body {
  padding: 0;
}

.import-export-tabs /deep/ .el-tabs__header {
  margin: 0;
}

.import-export-tabs /deep/ .el-tabs__content {
  padding: 20px;
  background: #f8f9fb;
}

.tab-pane-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.batch-week-range-row {
  margin-top: 12px;
  padding: 0 12px;
  align-items: flex-start;
}

.batch-week-range-pickers {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.batch-week-range-sep {
  color: #909399;
  font-size: 13px;
}

/* 导入结果页样式 - 恢复并优化 */
.result-summary-cards {
  display: flex;
  gap: 15px;
  margin-bottom: 5px;
}

.summary-card {
  flex: 1;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 15px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.summary-card.success .num {
  color: #67c23a;
  font-size: 28px;
  font-weight: bold;
}

.summary-card.clear .num {
  color: #e6a23c;
  font-size: 28px;
  font-weight: bold;
}

.summary-card.error .num {
  color: #909399;
  font-size: 28px;
  font-weight: bold;
}

.summary-card.error.active {
  border-color: #fde2e2;
  background: #fffbfa;
}

.summary-card.error.active .num {
  color: #f56c6c;
}

.summary-card .label {
  font-size: 13px;
  color: #606266;
  margin-top: 8px;
  font-weight: 500;
}

.result-detail-area {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.detail-header {
  padding: 12px 15px;
  background: #fef0f0;
  border-bottom: 1px solid #fde2e2;
  color: #f56c6c;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
}

.error-detail-scroll {
  height: 220px;
}

.error-list-v2 {
  padding: 5px 10px;
}

.error-item-v2 {
  display: flex;
  gap: 12px;
  padding: 10px;
  border-bottom: 1px solid #f5f7fa;
  font-size: 13px;
  line-height: 1.5;
  align-items: flex-start;
}

.error-item-v2:last-child {
  border-bottom: none;
}

.error-index {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  background: #f56c6c;
  color: #fff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
}

.error-text {
  color: #606266;
  flex: 1;
}

.result-success-tip {
  text-align: center;
  padding: 50px 0;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}

.result-success-tip i {
  font-size: 56px;
  color: #67c23a;
  margin-bottom: 20px;
}

.result-success-tip p {
  font-size: 18px;
  color: #303133;
  font-weight: bold;
}

.result-footer {
  text-align: center;
  margin-top: 5px;
}

/* 班次选择器 */
.class-selector-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
}

.selector-header {
  padding: 12px 15px;
  background: #f0f7ff;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.selector-header .header-left {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: bold;
  color: #303133;
}

.selector-header .label {
  font-size: 14px;
}

.selector-body {
  height: 220px;
  padding: 15px;
}

.class-item {
  width: 50%;
  display: inline-block;
  margin-bottom: 10px;
}

.selector-footer {
  padding: 15px;
  background: #fafafa;
  border-top: 1px solid #ebeef5;
}

.step-tip {
  font-size: 12px;
  color: #909399;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0 5px;
}

/* 上传配置 */
.upload-config-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.config-row {
  display: flex;
  align-items: center;
  gap: 15px;
}

.config-label {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
}

.upload-area /deep/ .el-upload,
.upload-area /deep/ .el-upload-dragger {
  width: 100%;
}

.import-action-bar {
  margin-top: 5px;
}

/* 导入结果页样式 */
.result-summary-cards {
  display: flex;
  gap: 15px;
}

.summary-card {
  flex: 1;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 15px;
  text-align: center;
}

.summary-card.success .num {
  color: #67c23a;
  font-size: 24px;
  font-weight: bold;
}

.summary-card.clear .num {
  color: #e6a23c;
  font-size: 24px;
  font-weight: bold;
}

.summary-card.error .num {
  color: #909399;
  font-size: 24px;
  font-weight: bold;
}

.summary-card.error.active .num {
  color: #f56c6c;
}

.summary-card .label {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}

.result-detail-area {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
}

.detail-header {
  padding: 10px 15px;
  background: #fff5f5;
  border-bottom: 1px solid #ffdbdb;
  color: #f56c6c;
  font-size: 13px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
}

.error-detail-scroll {
  height: 200px;
}

.error-list-v2 {
  padding: 10px;
}

.error-item-v2 {
  display: flex;
  gap: 10px;
  padding: 8px;
  border-bottom: 1px solid #f5f7fa;
  font-size: 12px;
  line-height: 1.4;
}

.error-item-v2:last-child {
  border-bottom: none;
}

.error-index {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  background: #fef0f0;
  color: #f56c6c;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.error-text {
  color: #606266;
}

.result-success-tip {
  text-align: center;
  padding: 40px 0;
  color: #67c23a;
}

.result-success-tip i {
  font-size: 48px;
  margin-bottom: 15px;
}

.result-success-tip p {
  font-size: 16px;
  font-weight: bold;
}

.result-footer {
  text-align: center;
  margin-top: 10px;
}

.import-result-area {
  margin-top: 15px;
}

.error-list {
  max-height: 120px;
  overflow-y: auto;
  margin-top: 10px;
  font-size: 12px;
  color: #f56c6c;
  background: #fff;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #fde2e2;
}

.error-item {
  margin-bottom: 6px;
  padding-bottom: 4px;
  border-bottom: 1px dashed #fde2e2;
}

.error-item:last-child {
  border-bottom: none;
}

.tab-content {
  padding: 6px 0 0;
}

.tab-content--week {
  padding-top: 4px;
}

.tab-content--calendar {
  padding-top: 4px;
}

.week-template-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  padding: 6px 10px;
  background: #fafbfd;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

.week-template-bar__split {
  width: 1px;
  height: 18px;
  background: #e4e7ed;
  margin: 0 2px;
}

.tab-toolbar {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.tip-text {
  color: #909399;
  font-size: 12px;
  margin-bottom: 8px;
}

/* 简洁清爽的 Tab 样式 */
.schedule-dialog-body /deep/ .el-tabs--card>.el-tabs__header {
  border-bottom: 1px solid #e4e7ed;
  margin-bottom: 0;
  background: transparent !important;
}

.schedule-dialog-body /deep/ .el-tabs--card>.el-tabs__header .el-tabs__nav {
  border: none !important;
}

.schedule-dialog-body /deep/ .el-tabs--card>.el-tabs__header .el-tabs__item {
  border: none !important;
  background: transparent !important;
  height: 34px;
  line-height: 34px;
  font-weight: 500;
  color: #909399 !important;
  padding: 0 16px;
  transition: all 0.3s;
  position: relative;
  font-size: 13px;
}

.schedule-dialog-body /deep/ .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
  color: var(--btn-primary, #2563eb) !important;
  background: #fff !important;
}

.schedule-dialog-body /deep/ .el-tabs--card>.el-tabs__header .el-tabs__item.is-active::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 2px;
  background: var(--btn-primary, #2563eb);
}

.schedule-dialog-body /deep/ .el-tabs--card>.el-tabs__content {
  background: #fff;
  border: none;
  padding: 0 10px 10px;
}

.week-table {
  width: 100%;
}

.week-table /deep/ th {
  padding: 6px 0 !important;
  background: #f8f9fb;
}

.week-table /deep/ td {
  vertical-align: middle;
  padding: 4px 0 !important;
}

.week-table /deep/ .cell {
  padding: 4px 8px;
  line-height: 1.35;
}

.teacher-tag-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
}

.week-teacher-block {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
}

.week-lock-pair-hint {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 10px;
  font-size: 11px;
  color: #606266;
  margin-top: 3px;
  max-width: 280px;
  line-height: 1.35;
  padding: 3px 8px 3px 9px;
  background: #fafbfc;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  border-left: 3px solid #e6a23c;
}

.week-lock-pair-hint strong {
  color: #303133;
  font-weight: 600;
}

.week-lock-pair-item--block {
  display: block;
  width: 100%;
}

.week-lock-pair-muted {
  margin-left: 4px;
  font-size: 10px;
  color: #909399;
  font-weight: 400;
}

.week-lock-date-hint {
  font-size: 11px;
  color: #e6a23c;
  margin-top: 2px;
  max-width: 240px;
  line-height: 1.4;
}

/* 月历工具条 */
.card-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 6px 10px;
  margin-bottom: 8px;
  background: #fafbfd;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

.calendar-month-picker {
  width: 130px;
}

.calendar-month-picker /deep/ .el-input__inner {
  height: 28px;
  line-height: 28px;
}

.calendar-toolbar-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-left: auto;
}

.calendar-hint--bar {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 6px 10px;
  margin-bottom: 8px;
  background: #ecf5ff;
  border: 1px solid #d9ecff;
  border-radius: 6px;
  color: var(--btn-primary, #2563eb);
  font-size: 12px;
  line-height: 1.45;
}

.calendar-hint--compact {
  padding: 5px 10px;
  margin-bottom: 8px;
  font-size: 12px;
}

.calendar-panel-v2 {
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
}

.calendar-v2-head {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  background: #f8f9fb;
  border-bottom: 1px solid #e4e7ed;
}

.calendar-v2-head-cell {
  padding: 8px 0;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: #606266;
}

.calendar-v2-body {
  position: relative;
}

.calendar-v2-week {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  border-bottom: 1px solid #f0f2f5;
}

.calendar-v2-day {
  min-height: 64px;
  padding: 5px 6px 6px;
  border-right: 1px solid #f0f2f5;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
}

.calendar-v2-day:hover {
  background: #f5f7fa;
}

.calendar-v2-day.is-other {
  background: #fafbfc;
  opacity: 0.6;
}

.calendar-v2-day.is-today {
  background: #f0f7ff;
}

.calendar-v2-day.is-today .calendar-v2-day-num {
  color: var(--btn-primary, #2563eb);
  font-weight: bold;
}

.calendar-v2-day-num {
  font-size: 12px;
  color: #303133;
  margin-bottom: 6px;
  flex-shrink: 0;
}

.calendar-v2-day-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-height: 0;
}

.calendar-v2-teacher {
  font-size: 11px;
  color: var(--btn-primary, #2563eb);
  background: #ecf5ff;
  padding: 1px 5px;
  border-radius: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.calendar-v2-teacher--adj {
  white-space: normal;
  background: transparent !important;
  padding: 0 !important;
  border-radius: 0;
  overflow: visible;
  width: 100%;
  align-self: stretch;
}

.calendar-v2-adj-card {
  width: 100%;
  min-width: 0;
  border-radius: 6px;
  border: 1px solid #e4e7ed;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  border-left: 3px solid #e6a23c;
}

.calendar-v2-adj-head {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 5px 7px 0;
  background: linear-gradient(180deg, #fafbfc 0%, #fff 55%);
}

.calendar-v2-adj-badge {
  display: inline-block;
  padding: 1px 7px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.5;
  color: #b88230;
  background: #fdf6ec;
  border: 1px solid #f5dab1;
  border-radius: 10px;
}

.calendar-v2-adj-body {
  padding: 2px 8px 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.calendar-v2-adj-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  font-size: 11px;
  line-height: 1.35;
}

.calendar-v2-adj-k {
  flex-shrink: 0;
  min-width: 1.75em;
  text-align: center;
  padding: 1px 0;
  font-size: 10px;
  font-weight: 600;
  color: #606266;
  background: #f0f2f5;
  border-radius: 3px;
}

.calendar-v2-adj-name {
  flex: 1;
  min-width: 0;
  font-weight: 500;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.calendar-v2-adj-name--act {
  color: var(--btn-primary, #2563eb);
  font-weight: 600;
}

.calendar-v2-adjust-tag {
  margin-left: 4px;
  color: #e6a23c;
  font-weight: 600;
}

/* ── 编辑某天排班弹窗样式 (由于 append-to-body，需在全局或非 scoped 中定义) ── */
</style>

<style>
/* 班次新增/编辑弹窗外壳 */
.scs-session-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 12px 48px rgba(47, 62, 82, 0.16);
}

.scs-session-dialog .el-dialog__header {
  padding: 16px 20px 12px;
  background: linear-gradient(180deg, #fafbfd 0%, #fff 100%);
  border-bottom: 1px solid #ebeef5;
}

.scs-session-dialog .el-dialog__title {
  font-size: 17px;
  font-weight: 600;
  color: #1f2a37;
}

.scs-session-dialog .el-dialog__body {
  padding: 14px 18px 6px;
  max-height: 72vh;
  overflow-y: auto;
  background: #f4f6f9;
}

.scs-session-dialog .el-dialog__footer {
  padding: 12px 18px 16px;
  background: #fff;
  border-top: 1px solid #ebeef5;
}

.edit-day-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 12px 48px rgba(47, 62, 82, 0.18);
}

.edit-day-dialog .el-dialog__header {
  padding: 16px 20px 12px;
  background: linear-gradient(180deg, #fafbfd 0%, #fff 100%);
  border-bottom: 1px solid #ebeef5;
}

.edit-day-dialog .el-dialog__title {
  font-size: 17px;
  font-weight: 600;
  color: #303133;
}

.edit-day-dialog .el-dialog__body {
  padding: 16px 22px 8px;
}

.edit-day-dialog .el-dialog__footer {
  padding: 14px 20px;
  background: #fafbfd;
  border-top: 1px solid #ebeef5;
}

.edit-day-dialog-sub {
  margin: 0 0 16px;
  font-size: 13px;
  color: #909399;
  line-height: 1.55;
}

.edit-day-list {
  max-height: 48vh;
  overflow-y: auto;
  padding-right: 4px;
}

.edit-day-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 12px 14px;
  margin-bottom: 10px;
  background: #fafbfd;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.edit-day-row:hover {
  border-color: #c6e2ff;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.08);
}

.edit-day-row__badge {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ecf5ff;
  color: var(--btn-primary, #2563eb);
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.edit-day-row__name {
  flex: 1;
  min-width: 120px;
  font-size: 13px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.edit-day-row__sort-label {
  flex-shrink: 0;
  font-size: 12px;
  color: #909399;
}

.edit-day-row__sort-input {
  width: 100px !important;
}

.edit-day-row__lock-tag {
  flex-shrink: 0;
}

.edit-day-row__del {
  flex-shrink: 0;
}

.edit-day-add {
  width: 100%;
  margin-top: 4px;
  height: 40px;
  border-radius: 8px;
  border-style: dashed;
}

.edit-day-dialog-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}

.edit-day-dialog-footer__right {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}

.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.scope-tag-text {
  display: inline-block;
  vertical-align: bottom;
  white-space: nowrap;
}

/* 列表两两合并列：主信息 + 副信息上下叠层 */
.scs-session-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  line-height: 1.35;
  padding: 2px 0;
  width: 100%;
  min-width: 0;
}

.scs-session-cell--center {
  align-items: center;
}

.scs-session-cell__name {
  max-width: 100%;
  color: #303133;
  font-size: 13px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.scs-session-cell__name--normal {
  font-weight: 500;
}

.scs-session-cell__sub {
  max-width: 100%;
  color: #909399;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
